export default {
  common: {
    close: "বন্ধ কৰক"
  },
  splash: {
    tagline: "কেৱল এটা চেটবট নহয় — আপোনাৰ কল্যাণৰ বাবে এটা নিৰাপদ, উষ্ণ স্থান।",
    welcome: "স্বাগতম — আপোনাৰ কল্যাণত প্ৰতিটো পদক্ষেপত সহায় কৰা।",
    startButton: "আৰম্ভ কৰিবলৈ টেপ কৰক",
    continue: "অব্যাহত ৰাখক",
    skip: "ইণ্ট্ৰ' বাদ দিয়ক",
    loading: "ল'ড হৈ আছে...",
    videoLabel: "মৈত্ৰী পৰিচয় ভিডিঅ'",
    videoNotSupported: "আপোনাৰ ব্ৰাউজাৰে ভিডিঅ' টেগ সমৰ্থন নকৰে।",
    mobileTagline: "মানসিক কল্যাণৰ বাবে আপোনাৰ যত্নশীল সঙ্গী।",
    tapToPlay: "ভিডিঅ' চলাবলৈ টেপ কৰক"
  },
  navbar: {
    title: "মৈত্রী",
    feelingDown: "মনটো ভাল নাই নেকি? মৈত্ৰীৰ সৈতে এটা নতুন সঙ্গী বিচাৰক।",
    hello: "নমস্কাৰ, {{name}}",
    home: "হোম",
    dashboard: "ডেশ্বব'ৰ্ড",
    about: "মৈত্ৰীৰ বিষয়ে",
    analysis: "বিশ্লেষণ",
    settings: "ছেটিংছ",
    talkToCounselor: "স্বাস্থ্যসেৱা পেছাদাৰীসকলৰ সৈতে কথা-বাৰ্তা",
    logout: "লগআউট"
  },
  dashboard: {
    tab: {
      chatbot: "চেটবট",
      chart: "প্ৰগতি",
      todo: "কৰিবলগীয়া কাম",
      reminder: "ৰিমাইণ্ডাৰ",
      dementia: "ডিমেনচিয়া চেকাৰ",
      treasure: "কেম্পাছ হাইলাইটছ",
      notFound: "টেব পোৱা নগ'ল"
    },
    loading: "আপোনাৰ ডেশ্বব'ৰ্ড লোড হ'বলৈ অপেক্ষা কৰক...",
    error: {
      generic: "এটা ত্ৰুটি হৈছে। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
      sessionCheckFailed: "ছেছন পৰীক্ষা বিফল:",
      fetchFailed: "ডেশ্বব'ৰ্ডৰ তথ্য আহৰণ কৰোঁতে ত্ৰুটি:",
      updateTodosFailed: "কামবোৰ আপডেট কৰিব পৰা নগ'ল:"
    },
    downloadReport: "ৰিপোৰ্ট ডাউনলোড কৰক",
    downloading: "ৰিপোৰ্ট প্ৰস্তুত কৰি আছে..."
  },
  maitriTreasure: {
    title: "গুৱাহাটী বিশ্ববিদ্যালয়ৰ অনুসন্ধান কৰক",
    description: "কেণ্টিন, খাদ্যস্থান আৰু কেম্পাছৰ হেংআউট স্থানবোৰ অন্বেষণ কৰক। বন্ধু-বান্ধৱীৰ লগত মিলিত হওক, আহাৰ উপভোগ কৰক আৰু গুৱাহাটী বিশ্ববিদ্যালয়ৰ উজ্জ্বল জীৱন অনুভৱ কৰক।",
    faqsTitle: "সাধাৰণ প্ৰশ্নসমূহ",
    startButton: "অনুসন্ধান আৰম্ভ কৰক",
    carouselAlt0: "গুৱাহাটী বিশ্ববিদ্যালয়ৰ স্থান ১",
    carouselAlt1: "গুৱাহাটী বিশ্ববিদ্যালয়ৰ স্থান ২",
    carouselAlt2: "গুৱাহাটী বিশ্ববিদ্যালয়ৰ স্থান ৩",
    faqs: [
      { question: "মৈত্রী ট্রেজাৰ কি?", answer: "গুৱাহাটী বিশ্ববিদ্যালয়ৰ সন্ধান কৰিবলৈ, ইয়াৰ কেণ্টিন, খাদ্যস্থান আৰু সামাজিক হেংআউটবোৰ অন্বেষণ কৰাৰ বাবে এখন প্লেটফৰ্ম।" },
      { question: "কে অংশগ্ৰহণ কৰিব পাৰে?", answer: "গুৱাহাটী বিশ্ববিদ্যালয়ৰ সকলো ছাত্ৰ-ছাত্রী আৰু কৰ্মচাৰী স্বাগতম।" },
      { question: "এইটো কি বিনামূল্যে?", answer: "হয়, ই সম্পূর্ণৰূপে বিনামূল্যতে ব্যৱহাৰ কৰিবলৈ আৰু উপভোগ কৰিবলৈ।" },
      { question: "মই কেনেকৈ আৰম্ভ কৰিম?", answer: "'ট্ৰেজাৰ হান্ট আৰম্ভ কৰক' বুটামত ক্লিক কৰি কেম্পাছৰ অনুসন্ধান আৰম্ভ কৰক।" }
    ]
  },
  todo: {
    title: "মোৰ কৰিবলগীয়া কাম",
    placeholder: "নতুন কাম যোগ কৰক...",
    maxTasks: "অধিকতম 10টা কাম যোগ কৰিব পাৰিব।",
    empty: "এখনো কাম নাই — এটা যোগ কৰি আৰম্ভ কৰক।",
    completedAll: "সকলো কাম সম্পূৰ্ণ! শ্ৰেষ্ঠ কাম।",
    add: "যোগ কৰক",
    updateError: "চাৰ্ভাৰৰ সৈতে কাম মিলাবলৈ ত্ৰুটি হ'ল।",
    loading: "আপোনাৰ কামবোৰ লোড হৈ আছে...",
    deleteTask: "আপুনি কি '{{title}}' কামটো আঁতৰাব খোজে?"
  },
  chatbot: {
    welcomeAI: "নমস্কাৰ! মই বৈদ্য, আপোনাৰ AI স্বাস্থ্য সহায়ক। মই ইয়াত আপোনাৰ মানসিক স্বাস্থ্য মেট্ৰিক্স, স্ক্ৰীনিং স্ক'ৰ আৰু জ্ঞানাত্মক কাৰ্য্যৰ মূল্যায়ন কৰাত সহায় কৰিবলৈ আহিছো। মই আপোনাক কেইটামান প্ৰশ্ন সুধিম যাতে মই আপোনাৰ স্বাস্থ্য ভালদৰে বুজিব পাৰো। আজি আপুনি কেনে অনুভৱ কৰিছে?",
    inputPlaceholder: "আপোনাৰ বাৰ্তা ইয়াত লিখক...",
    sendButton: "পঠিয়াওক",
    loginPrompt: "চেট আৰম্ভ কৰিবলৈ অনুগ্ৰহ কৰি লগইন কৰক।",
    connectionError: "চাৰ্ভাৰৰ সৈতে সংযোগ কৰোঁতে ত্ৰুটি।",
    sendError: "ক্ষমা কৰিব, বাৰ্তাটো পঠিয়াব পৰা নগ'ল।",
    loading: "ল'ড হৈ আছে...",
    typing: "বট টাইপ কৰি আছে...",
    empty: "এতিয়ালৈকে কোনো বাৰ্তা নাই।",
    retryPrompt: "সংযোগ সমস্যা। পুনৰ চেষ্টা কৰিবলৈ ক্লিক কৰক।",
    retryMessage: "বাৰ্তা বিফল। পুনৰ চেষ্টা কৰিবলৈ ইয়াত ক্লিক কৰক।",
    title: "মৈত্ৰী বৈদ্য",
    description: "এই সহায়কে আপোনাৰ বাৰ্তাসমূহ স্বয়ংক্ৰিয়ভাৱে বুজে, প্ৰসংগ বিশ্লেষণ কৰে, আৰু আপোনাৰ পছন্দৰ ভাষাত উত্তৰ দিয়ে। আপোনাৰ ভাষাৰ পছন্দ localStorage-ত সংৰক্ষণ কৰা হয়, গতিকে এপ বন্ধ কৰাৰ পিছতো ই থাকি যায়।",
    benefitsTitle: "মুখ্য সুবিধা",
    benefit1: "AI স্বাভাৱিক কথোপকথন বুজে আৰু সঠিক উত্তৰ দিয়ে।",
    benefit2: "সকলো পাঠ স্বয়ংক্ৰিয়ভাৱে কাৰ্য্য চিনাক্ত কৰিবলৈ প্ৰক্ৰিয়াকৰণ কৰা হয়।",
    benefit3: "আপোনাৰ টু-ডু তালিকা আপোনাৰ চেটৰ ওপৰত ভিত্তি কৰি গতিশীলভাৱে আপডেট হয়।",
    benefit4: "উৎপাদনশীলতা ৰূপৰেখা দেখাবলৈ চাৰ্টসমূহ স্বয়ংক্ৰিয়ভাৱে ৰিফ্ৰেছ হয়।",
    benefit5: "লগ ইন কৰিলে ডিভাইচসমূহত স্মাৰ্ট ছেছন ছিংকিং।",
    benefit6: "বহু-ভাষা ইণ্টাৰফেচ, স্থায়ীভাৱে স্মৰণ কৰা হয়।",
    howItHelpsTitle: "ই আপোনাক কেনেকৈ সহায় কৰে",
    howItHelpsDescription: "কেৱল স্বাভাৱিকভাৱে কথা পাতক। চিস্টেমে কাৰ্য্য, সময়সূচী, ৰিমাইণ্ডাৰ, লক্ষ্য চাই থাকে আৰু পটভূমিত সকলো নিঃশব্দে আপডেট কৰে। কোনো কমান্ড ফৰ্মেটৰ প্ৰয়োজন নাই।",
    languageTitle: "ভাষাৰ পছন্দ কিয় গুৰুত্বপূৰ্ণ",
    languageDescription: "প্ৰতিটো উত্তৰ আপোনাৰ নিৰ্বাচিত ভাষালৈ অভিযোজিত হয়। আপোনাৰ ইণ্টাৰফেচ, বট বাৰ্তা, আৰু টু-ডু সাৰাংশ এক সুসংগত অভিজ্ঞতাৰ বাবে একে ভাষা অনুসৰণ কৰে।",
    sending: "পাঠাই আছে...",
    cognitive: {
      orientationScore: "অভিমুখীকৰণ স্ক'ৰ",
      memoryScore: "স্মৃতি স্ক'ৰ",
      attentionScore: "মনোযোগ স্ক'ৰ",
      languageScore: "ভাষা স্ক'ৰ",
      executiveScore: "কাৰ্যকাৰী স্ক'ৰ",
      cognitiveRiskLevel: "জ্ঞানীয় ঝুঁকিৰ স্তৰ",
      assessmentCreated: "জ্ঞানীয় মূল্যায়ন সফলতাৰে সৃষ্টি কৰা হ'ল!",
      viewInChart: "প্ৰগতি টেবত আপোনাৰ জ্ঞানীয় মূল্যায়ন ডাটা চাওক।",
      assessmentInfo: "আপোনাৰ জ্ঞানীয় মূল্যায়ন সংৰক্ষণ কৰা হৈছে আৰু চাৰ্টত দেখা যাব।",
    },
  },
  chart: {
    emotionalMetrics: "ভাৱনাগত কল্যাণ মেট্ৰিক্স",
    screeningMetrics: "স্ক্ৰীণিং মূল্যাংকন মেট্ৰিক্স",
    barChart: "বার চাৰ্ট",
    lineChart: "লাইন চাৰ্ট",
    noData: "এতিয়ালৈকে কোনো মেট্ৰিক্স উপলব্ধ নাই।",
    noMetrics: "প্ৰদৰ্শনৰ বাবে কোনো ডাটা উপলব্ধ নাই।",
    refresh: "ৰিফ্ৰেছ কৰক",
    stress: "মানসিক চাপ",
    happiness: "সুখ",
    anxiety: "উদ্বেগ",
    overallMood: "সৰ্বমোট মনোভাৱ",
    phq9: "PHQ-9",
    gad7: "GAD-7",
    ghq: "GHQ",
    mmse: "MMSE",
    moca: "MoCA",
    ace3: "ACE-III",
    minicog: "Mini-Cog",
    slums: "SLUMS",
    rudas: "RUDAS",
    title: "ব্যৱহাৰকাৰী মেট্ৰিক্স",
    dementiaMetrics: "জ্ঞানীয় হানি",
    dementiaRisk: "ডিমেনচিয়া ঝুঁকি",
    cognitiveRisk: "জ্ঞানীয় হানিৰ ঝুঁকি",
    progressReport: "প্ৰগতি প্ৰতিবেদন",
    infoTitle: "মেট্ৰিক্স অৱলোকন",
    infoDescription: "এই চাৰ্টে সময়ৰ সৈতে আপোনাৰ নিৰ্বাচিত মেট্ৰিক্সসমূহ দৃশ্যত প্ৰদৰ্শন কৰে। আপুনি ভাৱনাগত মেট্ৰিক্স, স্ক্ৰীণিং মূল্যায়ন, আৰু জ্ঞানীয় হানিৰ ঝুঁকিৰ মাজত টগল কৰিব পাৰে। ৰূপৰেখা চাবলৈ আপোনাৰ পছন্দৰ চাৰ্ট প্ৰকাৰ (বাৰ বা লাইন) নিৰ্বাচন কৰক।",
    definitions: "সংজ্ঞা",
    stressDefinition: "মনোবৈজ্ঞানিক আৰু শাৰীৰিক টানৰ মাপ (0-50)। উচ্চ স্ক'ৰে বাঢ়ি অহা মানসিক চাপৰ স্তৰ সূচায়, যিয়ে আপোনাৰ সামগ্ৰিক কল্যাণক প্ৰভাৱিত কৰিব পাৰে।",
    happinessDefinition: "ইতিবাচক অনুভূতি, সন্তুষ্টি, আৰু আনন্দৰ মাপ (0-50)। উচ্চ স্ক'ৰে অধিক সুখ আৰু জীৱনৰ সন্তুষ্টি প্ৰতিফলিত কৰে।",
    anxietyDefinition: "উদ্বেগ, উদ্বিগ্নতা, আৰু অশান্তিৰ মাপ (0-50)। উচ্চ স্ক'ৰে বাঢ়ি অহা উদ্বেগৰ স্তৰ সূচায় যি মনোযোগৰ প্ৰয়োজন হ'ব পাৰে।",
    overallMoodDefinition: "আপোনাৰ সাধাৰণ ভাৱনাগত অৱস্থাৰ এক সামগ্ৰিক মাপ (0-50)। ই কোনো নিৰ্দিষ্ট সময়ত আপোনাৰ সামগ্ৰিক মনোবৈজ্ঞানিক কল্যাণক প্ৰতিফলিত কৰে।",
    phq9Definition: "ৰোগী স্বাস্থ্য প্ৰশ্নাৱলী-9 (0-27)। এটা বৈধ 9-আইটেম হতাশা স্ক্ৰীণিং সঁজুলি। স্ক'ৰ: 0-4 (সৰ্বনিম্ন), 5-9 (মৃদু), 10-14 (মধ্যম), 15-19 (মধ্যমভাৱে গুৰুতৰ), 20-27 (গুৰুতৰ)।",
    gad7Definition: "সাধাৰণ উদ্বেগ ব্যাধি-7 (0-21)। এটা 7-আইটেম উদ্বেগ স্ক্ৰীণিং স্কেল। স্ক'ৰ: 0-4 (সৰ্বনিম্ন), 5-9 (মৃদু), 10-14 (মধ্যম), 15-21 (গুৰুতৰ উদ্বেগ)।",
    ghqDefinition: "সাধাৰণ স্বাস্থ্য প্ৰশ্নাৱলী (0-36)। মানসিক স্বাস্থ্যৰ স্থিতি মাপি থকা এটা ব্যাপক মনোবৈজ্ঞানিক দুৰ্গতি স্ক্ৰীণিং সঁজুলি। উচ্চ স্ক'ৰে অধিক মনোবৈজ্ঞানিক দুৰ্গতি সূচায়।",
    dementiaRiskDefinition: "জ্ঞানীয় হানিৰ বাবে ঝুঁকিৰ স্তৰ সূচোৱা এটা শতাংশ স্ক'ৰ (0-100%)। ব্যাপক গেম-ভিত্তিক জ্ঞানীয় মেট্ৰিক্সৰ ওপৰত ভিত্তি কৰি য'ত ভাৰযুক্ত ড'মেইন স্ক'ৰিং (মেমৰি 30%, ভাষা 20%, মনোযোগ 20%, অভিমুখীকৰণ 15%, কাৰ্যকাৰী 15%) অন্তৰ্ভুক্ত। নিম্ন স্ক'ৰে ভাল জ্ঞানীয় কাৰ্য্য সূচায়।",
    howScoringWorks: "ভাৱনাগত মেট্ৰিক্স কেনেকৈ স্ক'ৰ আৰু মূল্যায়ন কৰা হয়",
    scoringMethodology: "স্ক'ৰিং পদ্ধতি",
    emotionalScoringExplanation: "ভাৱনাগত মেট্ৰিক্স উন্নত প্ৰাকৃতিক ভাষা প্ৰসংসকৰণ (NLP) কৌশল ব্যৱহাৰ কৰি গণনা কৰা হয় যিয়ে চেটবটৰ সৈতে আপোনাৰ কথোপকথনৰ নমুনা বিশ্লেষণ কৰে। চিস্টেমে মনোবৈজ্ঞানিক ভাষা চিহ্ন (LIWC বৈশিষ্ট্য) ব্যৱহাৰ কৰে য'ত প্ৰথম-ব্যক্তি সৰ্বনাম ব্যৱহাৰৰ পুনৰাবৃত্তি, নেতিবাচক অনুভূতি শব্দৰ ঘনত্ব, জ্ঞানীয় প্ৰসংসকৰণ শব্দৰ পুনৰাবৃত্তি, অস্বচ্ছতা চিহ্ন ('um', 'uh'ৰ দৰে দ্বিধা শব্দ), আৰু পুনৰাবৃত্তিৰ নমুনা অন্তৰ্ভুক্ত। ইয়াৰ উপৰিও, ট্ৰান্সফৰ্মাৰ-ভিত্তিক এম্বেডিং (মানসিক-স্বাস্থ্য ডেটাছেটত ফাইন-টিউন কৰা Sentence-BERT/DistilBERT মডেল) ব্যৱহাৰ কৰা হয় নৈদানিক লক্ষণ বৰ্ণনাৰ সৈতে শব্দাৰ্থিক সাদৃশ্য ধৰিবলৈ। স্ক'ৰ 0-50 ৰ পৰিসৰত থাকে, য'ত উচ্চ মানে সেই ভাৱনাগত অৱস্থাৰ শক্তিশালী উপস্থিতি সূচায়।",
    evaluationProcess: "মূল্যায়ন প্ৰক্ৰিয়া",
    emotionalEvaluationProcess: "AI এ আপোনাৰ কথোপকথনৰ ইতিহাসক বেটছত বিশ্লেষণ কৰে, নমুনা, পুনৰাবৃত্তি উল্লেখ, আৰু সঞ্চিত ভাৱনাগত সূচক বিচাৰি। প্ৰতিটো মেট্ৰিক স্বাধীনভাৱে গণনা কৰা হয়: মানসিক চাপৰ স্তৰ মানসিক চাপকাৰী, শাৰীৰিক লক্ষণ, আৰু টান সূচকৰ উল্লেখৰ জৰিয়তে চিনাক্ত কৰা হয়। সুখ ইতিবাচক অনুভূতি, সন্তুষ্টিৰ অভিব্যক্তি, আৰু আনন্দ সূচকৰ জৰিয়তে মাপা হয়। উদ্বেগ উদ্বেগৰ নমুনা, উদ্বিগ্নতাৰ চিহ্ন, অশান্তি সূচক, আৰু আতংক-সম্পৰ্কীয় ভাষাৰ জৰিয়তে সনাক্ত কৰা হয়। সামগ্ৰিক মনোভাৱ এটা সামগ্ৰিক মাপ যি ওপৰৰ মেট্ৰিক্সৰ গড় হ'ব পাৰে বা সাধাৰণ ভাৱনাগত অৱস্থাৰ স্বাধীন মূল্যায়ন হ'ব পাৰে।",
    howScreeningScored: "স্ক্ৰীণিং মেট্ৰিক্স কেনেকৈ স্ক'ৰ আৰু মূল্যায়ন কৰা হয়",
    screeningMethodology: "স্ক'ৰিং পদ্ধতি",
    screeningScoringExplanation: "PHQ-9, GAD-7, আৰু GHQ স্ক'ৰ AI-অনুমানিত প্ৰক্সি সূচক যি কথোপকথনৰ নমুনা আৰু ভাষাগত বৈশিষ্ট্য বিশ্লেষণ কৰি গণনা কৰা হয়। AI এ সেই লক্ষণ আৰু আচৰণ চিনাক্ত কৰে যি মানকীকৃত প্ৰশ্নাৱলীৰ আইটেমৰ সৈতে মিলে। PHQ-9 ৰ বাবে, চিস্টেমে আগ্রহ হানি, মনোভাৱৰ পৰিবৰ্তন, টোপনিৰ ব্যাঘাত, শক্তিৰ স্তৰ, ক্ষুধাৰ পৰিবৰ্তন, মনোযোগৰ সমস্যা, আত্ম-মূল্যৰ উদ্বেগ, গতিৰ সমস্যা, আৰু আত্মহত্যাৰ চিন্তাৰ সূচক বিচাৰে। GAD-7 ৰ বাবে, ইয়ে অত্যধিক উদ্বেগ, অশান্তি, ক্লান্তি, মনোযোগৰ সমস্যা, খং, পেশীৰ টান, আৰু টোপনিৰ সমস্যা চিনাক্ত কৰে। GHQ ৰ বাবে, ইয়ে মনোবৈজ্ঞানিক দুৰ্গতি, সামাজিক কাৰ্য্য, আৰু শাৰীৰিক লক্ষণ মূল্যায়ন কৰে। এই স্ক'ৰবোৰে কথোপকথনৰ নমুনাৰ ওপৰত ভিত্তি কৰি সম্ভাৱনাৰ ভৱিষ্যতবাণী কৰে কিন্তু প্ৰকৃত প্ৰশ্নাৱলীৰ উত্তৰ নহয়।",
    importantNote: "গুৰুত্বপূৰ্ণ নোট",
    screeningImportantNote: "এই AI-অনুমানিত স্ক'ৰবোৰ স্ক্ৰীণিং সঁজুলি যি সম্ভাৱ্য উদ্বেগ চিনাক্ত কৰাত সহায় কৰে। এইবোৰ আপোনাৰ কথোপকথনৰ প্ৰাকৃতিক ভাষা বিশ্লেষণৰ ওপৰত ভিত্তি কৰি আৰু সাৱধানতাৰে ব্যাখ্যা কৰা উচিত। সত্যাপিত নৈদানিক ফলাফল আৰু আনুষ্ঠানিক নিৰ্দেশনাৰ বাবে, আপুনি স্বাস্থ্যৰক্ষা পেছাদাৰীসকলে প্ৰশাসন কৰা প্ৰকৃত মানকীকৃত PHQ-9, GAD-7, বা GHQ প্ৰশ্নাৱলী সম্পূৰ্ণ কৰিব লাগিব। এই প্ৰক্সি স্ক'ৰবোৰ সজাগতা বৃদ্ধি কৰিবলৈ আৰু সূচিত হ'লে পেছাদাৰী পৰামৰ্শক উৎসাহিত কৰিবলৈ ডিজাইন কৰা হৈছে।",
    howCognitiveScored: "জ্ঞানীয় মেট্ৰিক্স কেনেকৈ স্ক'ৰ আৰু মূল্যায়ন কৰা হয়",
    gameBasedScoring: "গেম-ভিত্তিক মূল্যায়ন স্ক'ৰিং",
    cognitiveScoringExplanation: "জ্ঞানীয় মেট্ৰিক্স বিভিন্ন জ্ঞানীয় গেমত আপোনাৰ কাৰ্য্যক্ষমতাৰ পৰা গণনা কৰা হয়। প্ৰতিটো গেম বৈধ নিউৰ'সাইক'লজিকেল পৰীক্ষাৰ প্ৰতিমানৰ ওপৰত ভিত্তি কৰি নিৰ্দিষ্ট জ্ঞানীয় ড'মেইন মূল্যায়ন কৰিবলৈ ডিজাইন কৰা হৈছে। প্ৰতিটো গেমৰ পৰা আপোনাৰ কেঁচা স্ক'ৰ ন্যায়সঙ্গত তুলনা নিশ্চিত কৰিবলৈ কঠিনতাৰ স্তৰ (সহজ, মধ্যম, কঠিন)ৰ দ্বাৰা স্বাভাৱিকীকৃত কৰা হয়। ব্যৱহৃত সূত্ৰ হ'ল: স্বাভাৱিকীকৃত স্ক'ৰ = (কেঁচা স্ক'ৰ / কঠিনতাৰ বাবে সৰ্বোচ্চ সম্ভৱ স্ক'ৰ) × 100। এই স্বাভাৱিকীকৰণে বিভিন্ন কঠিনতা গুণক (সহজ: 1.0x, মধ্যম: 1.5x, কঠিন: 2.0x) বিবেচনা কৰে আৰু নিশ্চিত কৰে যে স্ক'ৰবোৰ গেম আৰু কঠিনতাৰ স্তৰত তুলনাযোগ্য।",
    domainMapping: "গেম-থেকে-ড'মেইন মেপিং",
    domainMappingExplanation: "প্ৰতিটো গেম নৈদানিক ন্যায়সঙ্গততাৰ সৈতে নিৰ্দিষ্ট জ্ঞানীয় ড'মেইনলৈ মেপ কৰে: ডিজিট স্পেন আৰু N-Back প্ৰধানকৈ মেমৰি (কাৰ্য্যক্ষম মেমৰি ক্ষমতা) পৰীক্ষা কৰে। পেটাৰ্ণ ৰিকল আৰু মেমৰি মেচে মেমৰি আৰু মনোযোগ মূল্যায়ন কৰে। ৰিয়েকশন টাইমে মনোযোগ আৰু প্ৰসংসকৰণ গতি মাপে। ষ্ট্ৰুপ টেষ্টে কাৰ্যকাৰী কাৰ্য্য (জ্ঞানীয় নমনীয়তা আৰু নিষেধ) মূল্যায়ন কৰে। ক্লক ড্ৰইংয়ে কাৰ্যকাৰী কাৰ্য্য, অভিমুখীকৰণ, আৰু দৃশ্য-স্থানিক ক্ষমতা পৰীক্ষা কৰে। টেক্স্ট ৰিকল (ডিমেনচিয়া চেকাৰ) মেমৰি আৰু ভাষা মূল্যায়ন কৰে। প্ৰতিটো গেমে ভাৰযুক্ত গুৰুত্বৰ সৈতে ড'মেইন স্ক'ৰলৈ অৱদান আগবঢ়ায় যি এইটোৰ ওপৰত ভিত্তি কৰি যে ই প্ৰধানকৈ কোনটো জ্ঞানীয় কাৰ্য্য পৰীক্ষা কৰে।",
    weightedRiskCalculation: "ভাৰযুক্ত ঝুঁকি স্ক'ৰ গণনা",
    weightedRiskExplanation: "চূড়ান্ত জ্ঞানীয় ঝুঁকি স্ক'ৰে নৈদানিক গৱেষণাৰ ওপৰত ভিত্তি কৰি ভাৰযুক্ত ড'মেইন মডেল ব্যৱহাৰ কৰে: মেমৰি (30% ভাৰ) - মুখ্য প্ৰাৰম্ভিক ডিমেনচিয়া চিহ্ন, ভাষা (20%) - শব্দ-খোঁজাৰ সমস্যা প্ৰাৰম্ভিকতে দেখা যায়, মনোযোগ (20%) - কাৰ্যকাৰী হ্ৰাসে মনোযোগ নেটৱৰ্কক প্ৰভাৱিত কৰে, অভিমুখীকৰণ (15%) - মধ্যম প্ৰভাৱ, কাৰ্যকাৰী কাৰ্য্য (15%) - গুৰুত্বপূৰ্ণ কিন্তু সাধাৰণতে পিছৰ স্তৰৰ চিহ্ন। সূত্ৰে গণনা কৰে: ভাৰযুক্ত ঝুঁকি স্ক'ৰ = Σ(ড'মেইন ঝুঁকি × ড'মেইন ভাৰ), য'ত ড'মেইন ঝুঁকি = 1 - (ড'মেইন স্ক'ৰ / 10)। উচ্চ ড'মেইন স্ক'ৰ (0-10 স্কেল) ভাল জ্ঞানীয় কাৰ্য্য সূচায়, ফলত নিম্ন ঝুঁকি স্ক'ৰ (0-1 স্কেল) হয়। ঝুঁকিৰ স্তৰ নিৰ্ধাৰণ কৰা হয়: উচ্চ (≥70%), মধ্যম (40-69%), নিম্ন (<40%)।",
    whatEachGameTests: "প্ৰতিটো গেমে কি পৰীক্ষা কৰে",
    digitSpanGame: "ডিজিট স্পেন",
    digitSpanGameDesc: "আপোনাক অংকৰ ক্ৰম স্মৰণ ৰাখিবলৈ আৰু স্মৰণ কৰিবলৈ প্ৰয়োজন কৰি কাৰ্য্যক্ষম মেমৰি ক্ষমতা পৰীক্ষা কৰে। তাৎক্ষণিক মেমৰি স্পেন মাপে, যি জ্ঞানীয় স্বাস্থ্যৰ এটা মুখ্য সূচক। প্ৰাৰম্ভিক আলঝেইমাৰ ৰোগে চমু-ম্যাদী স্মৰণক প্ৰভাৱিত কৰে, যিয়ে এই পৰীক্ষাক প্ৰাৰম্ভিক জ্ঞানীয় হ্ৰাসৰ প্ৰতি সংবেদনশীল কৰি তোলে।",
    nBackGame: "N-Back",
    nBackGameDesc: "আপোনাক এটা ক্ৰমত N পদক্ষেপ পিছত দেখা দিয়া আইটেমবোৰ চিনাক্ত কৰিবলৈ প্ৰয়োজন কৰি কাৰ্য্যক্ষম মেমৰি আৰু কাৰ্যকাৰী কাৰ্য্য মূল্যায়ন কৰে। কাৰ্য্যক্ষম মেমৰিত তথ্য ৰাখিবলৈ আৰু আপডেট কৰিবলৈ আপোনাৰ ক্ষমতা পৰীক্ষা কৰে, যি মৃদু জ্ঞানীয় হানি (MCI) হ্ৰাসৰ প্ৰতি সংবেদনশীল।",
    patternRecallGame: "পেটাৰ্ণ ৰিকল",
    patternRecallGameDesc: "আপোনাক দৃশ্য পেটাৰ্ণ স্মৰণ ৰাখিবলৈ আৰু পুনৰ উৎপাদন কৰিবলৈ প্ৰয়োজন কৰি দৃশ্য মেমৰি আৰু ক্ৰমিক প্ৰসংসকৰণ পৰীক্ষা কৰে। মেমৰি এনকোডিং আৰু পুনৰুদ্ধাৰ ঘাটি মূল্যায়ন কৰে, যি গুৰুত্বপূৰ্ণ জ্ঞানীয় কাৰ্য্য যি প্ৰাৰম্ভিক-স্তৰৰ ডিমেনচিয়াত হ্ৰাস পায়।",
    memoryMatchGame: "মেমৰি মেচ",
    memoryMatchGameDesc: "আপোনাক তেওঁলোকৰ স্থান স্মৰণ ৰাখি কাৰ্ডৰ যোৰ মিলাবলৈ প্ৰয়োজন কৰি সহযোগী মেমৰি মূল্যায়ন কৰে। হিপ্পোকেম্পেল-নিৰ্ভৰশীল মেমৰি চিস্টেম পৰীক্ষা কৰে, যি প্ৰাৰম্ভিক আলঝেইমাৰ ৰোগত দৃঢ়তাৰে প্ৰভাৱিত হয়। দৃশ্য মেমৰি ঘাটি আৰু স্থানিক প্ৰসংসকৰণ সমস্যা চিনাক্ত কৰে।",
    reactionTimeGame: "ৰিয়েকশন টাইম",
    reactionTimeGameDesc: "দৃশ্য উদ্দীপনাৰ বাবে দ্ৰুত প্ৰতিক্ৰিয়াৰ প্ৰয়োজন কৰি প্ৰসংসকৰণ গতি আৰু মনোযোগ মাপে। ধীৰ জ্ঞানীয় প্ৰসংসকৰণ সনাক্ত কৰে, যি জ্ঞানীয় হ্ৰাসৰ এটা প্ৰাৰম্ভিক সূচক। গড় প্ৰতিক্ৰিয়া সময়, পৰিৱৰ্তনশীলতা, আৰু আটাইতকৈ ধীৰ 10% প্ৰতিক্ৰিয়া ট্ৰেক কৰে।",
    colorSequenceGame: "ৰং ক্ৰম",
    colorSequenceGameDesc: "আপোনাক ক্ৰমত ৰং ক্ৰম স্মৰণ ৰাখিবলৈ আৰু পুনৰাবৃত্তি কৰিবলৈ প্ৰয়োজন কৰি ক্ৰমিক মেমৰি পৰীক্ষা কৰে। কাৰ্য্যক্ষম মেমৰি আৰু কাৰ্যকাৰী কাৰ্য্য উপাদান মূল্যায়ন কৰে যি প্ৰাৰম্ভিক ডিমেনচিয়াত প্ৰভাৱিত হয়। মেমৰিত ক্ৰম ৰাখিবলৈ ক্ষমতা মাপে।",
    stroopTestGame: "ষ্ট্ৰুপ টেষ্ট",
    stroopTestGameDesc: "আপোনাক বিৰোধী পাঠ ৰং উপেক্ষা কৰি ৰং নাম চিনাক্ত কৰিবলৈ প্ৰয়োজন কৰি জ্ঞানীয় নমনীয়তা আৰু নিষেধ মূল্যায়ন কৰে। কাৰ্যকাৰী কাৰ্য্য আৰু জ্ঞানীয় নিয়ন্ত্ৰণ মাপে, যি ডিমেনচিয়া ৰোগীত ক্ষতিগ্ৰস্ত হয়। স্বয়ংক্ৰিয় প্ৰতিক্ৰিয়া নিষেধ কৰিবলৈ ক্ষমতা পৰীক্ষা কৰে।",
    clockDrawingGame: "ক্লক ড্ৰইং",
    clockDrawingGameDesc: "ডিমেনচিয়াৰ বাবে ব্যাপকভাৱে ব্যৱহৃত স্ক্ৰীণিং সঁজুলি যি দৃশ্য-স্থানিক দক্ষতা, কাৰ্যকাৰী কাৰ্য্য, মনোযোগ, আৰু শব্দাৰ্থিক মেমৰি অন্তৰ্ভুক্ত কৰি কেইবাটাও জ্ঞানীয় ড'মেইন মূল্যায়ন কৰে। এইটো এটা নৈদানিকভাৱে বৈধ পৰীক্ষা (CDT) যি MMSE, MoCA, আৰু অন্যান্য মূল্যায়নত ব্যৱহৃত হয়। ক্লক ড্ৰইংত হানি জ্ঞানীয় হ্ৰাসৰ শক্তিশালী সূচক।",
    textRecallGame: "টেক্স্ট ৰিকল",
    textRecallGameDesc: "আপোনাক পাঠ অংশ পঢ়িবলৈ আৰু স্মৰণ কৰিবলৈ প্ৰয়োজন কৰি মেমৰি আৰু ভাষা মূল্যায়ন কৰে। মৌখিক মেমৰি, ভাষা বুজাবুজি, আৰু ধাৰণ ক্ষমতা পৰীক্ষা কৰে। প্ৰাৰম্ভিক আলঝেইমাৰৰ বৈশিষ্ট্যত মেমৰি আৰু ভাষা ঘাটি অন্তৰ্ভুক্ত, যিয়ে এই পৰীক্ষাক প্ৰাৰম্ভিক সনাক্তকৰণৰ বাবে অতি প্ৰাসংগিক কৰি তোলে।",
    primaryDomain: "প্ৰাথমিক ড'মেইন",
    secondaryDomain: "দ্বিতীয়",
    importantDisclaimer: "গুৰুত্বপূৰ্ণ অস্বীকৃতি",
    disclaimerTitle: "মূল্যায়ন উদ্দেশ্য",
    disclaimerText1: "এই জ্ঞানীয় মূল্যায়নবোৰ কেৱল স্ক্ৰীণিং আৰু আত্ম-মূল্যায়ন উদ্দেশ্যৰ বাবে ডিজাইন কৰা হৈছে। এইবোৰ বৈধ নিউৰ'সাইক'লজিকেল পৰীক্ষাৰ প্ৰতিমানৰ ওপৰত ভিত্তি কৰি কিন্তু পেছাদাৰী চিকিৎসা মূল্যায়ন, নিৰ্দেশনা, বা চিকিৎসা প্ৰতিস্থাপন কৰিবলৈ উদ্দেশ্য নহয়।",
    disclaimerTitle2: "নৈদানিক ব্যাখ্যা",
    disclaimerText2: "ফলাফলবোৰ যোগ্য স্বাস্থ্যৰক্ষা পেছাদাৰীসকলে ব্যাপক নৈদানিক মূল্যায়ন, চিকিৎসা ইতিহাস, আৰু উপযুক্ত নৈদানিক পৰীক্ষাৰ সৈতে মিলি ব্যাখ্যা কৰা উচিত। স্ক'ৰবোৰ ক্লান্তি, মানসিক চাপ, ঔষধৰ প্ৰভাৱ, বা অস্থায়ী স্বাস্থ্য অৱস্থাৰ দৰে কাৰকৰ দ্বাৰা প্ৰভাৱিত হ'ব পাৰে।",
    disclaimerTitle3: "নিৰ্দেশনা নহয়",
    disclaimerText3: "প্লেটফৰ্মে চিকিৎসা নিৰ্দেশনা, চিকিৎসা পৰামৰ্শ, বা নৈদানিক সিদ্ধান্ত-গ্ৰহণ সহায়তা প্ৰদান নকৰে। যিকোনো চিকিৎসা উদ্বেগ বা স্বাস্থ্য-সম্পৰ্কীয় সিদ্ধান্ত লোৱাৰ আগতে সদায় লাইচেন্সযুক্ত স্বাস্থ্যৰক্ষা পেছাদাৰীসকলৰ সৈতে পৰামৰ্শ কৰক।",
    proxyDisclaimer: "AI-অনুমানিত প্ৰক্সি স্ক'ৰ",
    proxyDisclaimerText: "ইয়াত দেখুওৱা PHQ-9, GAD-7, আৰু GHQ স্ক'ৰবোৰ কথোপকথনৰ নমুনাৰ ওপৰত ভিত্তি কৰি AI-অনুমানিত প্ৰক্সি সূচক, প্ৰকৃত প্ৰশ্নাৱলীৰ উত্তৰ নহয়। সত্যাপিত নৈদানিক ফলাফলৰ বাবে, ব্যৱহাৰকাৰীসকলে মানকীকৃত প্ৰশ্নাৱলী সম্পূৰ্ণ কৰিব লাগিব।",
    aiEstimated: "AI-অনুমানিত",
    emotionalMetricsDisclaimer: "AI-অনুমানিত মেট্ৰিক্স",
    emotionalMetricsDisclaimerText: "ভাৱনাগত মেট্ৰিক্স (মানসিক চাপ, উদ্বেগ, সুখ) মনোবৈজ্ঞানিক ভাষা চিহ্ন (LIWC বৈশিষ্ট্য: প্ৰথম-ব্যক্তি ব্যৱহাৰ, নেতিবাচক অনুভূতি শব্দ, জ্ঞানীয় প্ৰসংসকৰণ শব্দ) আৰু ট্ৰান্সফৰ্মাৰ এম্বেডিং (মানসিক-স্বাস্থ্য ডেটাছেটত ফাইন-টিউন কৰা Sentence-BERT/DistilBERT) ব্যৱহাৰ কৰি AI-অনুমানিত, নৈদানিকভাৱে বৈধ নৈদানিক সঁজুলি নহয়।",
    cognitiveAssessmentDisclaimer: "জ্ঞানীয় স্ক'ৰ কথোপকথন ভাষাগত বৈশিষ্ট্যৰ পৰা অনুমানিত (মেমৰি চিহ্ন, অভিমুখীকৰণ চিহ্ন, মনোযোগ চিহ্ন, ভাষা চিহ্ন, কাৰ্যকাৰী কাৰ্য্য চিহ্ন), আনুষ্ঠানিক নিউৰ'সাইক'লজিকেল পৰীক্ষা নহয়।",
    noDataTitle: "কোনো ডাটা উপলব্ধ নাই",
    refreshing: "ৰিফ্ৰেছ হৈ আছে...",
    average: "গড়",
    maximum: "সৰ্বোচ্চ",
    minimum: "সৰ্বনিম্ন",
    dataPoints: "ডাটা বিন্দু",
    metricType: "মেট্ৰিক প্ৰকাৰ",
    chartType: "চাৰ্ট প্ৰকাৰ",
    infoSubtitle: "আপোনাৰ মানসিক স্বাস্থ্য আৰু জ্ঞানীয় কল্যাণ ট্ৰেক কৰক",
    feature1Title: "ৰিয়েল-টাইম ট্ৰেকিং",
    feature1Desc: "সময়ৰ সৈতে পৰিবৰ্তন মনিটৰ কৰক",
    feature2Title: "বহুতো মেট্ৰিক্স",
    feature2Desc: "ভাৱনাগত, স্ক্ৰীণিং আৰু জ্ঞানীয়",
    feature3Title: "দৃশ্য অন্তৰ্দৃষ্টি",
    feature3Desc: "বাৰ আৰু লাইন চাৰ্ট বিকল্প",
    feature4Title: "অ'ট' ৰিফ্ৰেছ",
    feature4Desc: "নৱীনতম ডাটাৰ সৈতে আপডেট থাকক",
    domainWeights: "ড'মেইন ভাৰ",
    memoryWeightReason: "মুখ্য প্ৰাৰম্ভিক ডিমেনচিয়া চিহ্ন - হিপ্পোকেম্পেল-নিৰ্ভৰশীল",
    languageWeightReason: "আলঝেইমাৰত শব্দ-খোঁজাৰ সমস্যা প্ৰাৰম্ভিকতে দেখা যায়",
    attentionWeightReason: "কাৰ্যকাৰী হ্ৰাসে মনোযোগ নেটৱৰ্কক প্ৰভাৱিত কৰে",
    orientationWeightReason: "মধ্যম প্ৰভাৱ, পিছৰ স্তৰত অধিক প্ৰভাৱিত",
    executiveWeightReason: "গুৰুত্বপূৰ্ণ কিন্তু সাধাৰণতে পিছৰ স্তৰৰ চিহ্ন",
    reactionTimeDefinition: "প্ৰসংসকৰণ গতি আৰু মনোযোগ মাপে। গড় প্ৰতিক্ৰিয়া সময়, পৰিৱৰ্তনশীলতা, আৰু আটাইতকৈ ধীৰ 10% মুখ্য সূচক। নিম্ন সময়ে ভাল জ্ঞানীয় কাৰ্য্য সূচায়।",
    accuracyDefinition: "সামগ্ৰিক জ্ঞানীয় দক্ষতা শুদ্ধ শতাংশ হিচাপে মাপা হয়। ত্ৰুটিৰ প্ৰকাৰ আৰু সময়ৰ চাপত নিৰ্ভুলতা ট্ৰেক কৰে। উচ্চ নিৰ্ভুলতাই ভাল জ্ঞানীয় কাৰ্য্য সূচায়।",
    workingMemoryDefinition: "চমু-ম্যাদী মেমৰি ক্ষমতা। স্মৰণ কৰা সৰ্বোচ্চ ক্ৰম, আগলৈ বনাম পিছলৈ স্পেন, আৰু অনুপ্ৰৱেশ ত্ৰুটি মাপে। উচ্চ স্পেনে ভাল কাৰ্য্যক্ষম মেমৰি সূচায়।",
    executiveFunctionDefinition: "সিদ্ধান্ত গ্ৰহণ, পৰিকল্পনা, আৰু নিষেধ ক্ষমতা। কাৰ্য্য-সুইচিং গতি, নিয়ম উলংঘন, আৰু দৃঢ়তা ট্ৰেক কৰে। নিম্ন সময় আৰু কম উলংঘনে ভাল কাৰ্যকাৰী কাৰ্য্য সূচায়।",
    visuospatialDefinition: "স্থানিক যুক্তি আৰু দৃশ্য প্ৰসংসকৰণ। আকৃতি পুনৰ নিৰ্মাণ কৰাত নিৰ্ভুলতা, নেভিগেশ্যন ত্ৰুটি, আৰু ধাঁধা সম্পূৰ্ণতাৰ সময় মাপে। উচ্চ নিৰ্ভুলতাই ভাল দৃশ্য-স্থানিক কাৰ্য্য সূচায়।",
    attentionDefinition: "অব্যাহত মনোযোগ আৰু ফোকাছ। কাৰ্য্যত সময়, বিক্ষেপক ক্লিক হাৰ, হেৰুওৱা উদ্দীপনা, আৰু স্থিৰতা স্ক'ৰ ট্ৰেক কৰে। উচ্চ স্থিৰতাই ভাল মনোযোগ সূচায়।",
    processingSpeedDefinition: "জ্ঞানীয় প্ৰসংসকৰণৰ গতি। গড় গেম সম্পূৰ্ণতাৰ সময়, আটাইতকৈ দ্ৰুত আৰু আটাইতকৈ ধীৰ গেম সময়, আৰু গতি স্থিৰতা মাপে। নিম্ন সময়ে দ্ৰুত প্ৰসংসকৰণ সূচায়।",
    learningCurveDefinition: "সময়ৰ সৈতে শিকিবলৈ আৰু উন্নতি কৰিবলৈ ক্ষমতা। প্ৰথমৰ পৰা শেষ পৰীক্ষালৈ উন্নতি, পাহৰা বক্ৰ, আৰু ধাৰণ হাৰ মাপে। ইতিবাচক উন্নতিয়ে ভাল শিকাৰ ক্ষমতা সূচায়।",
    errorAnalyticsDefinition: "ত্ৰুটিৰ নমুনা আৰু প্ৰকাৰ। মুঠ ত্ৰুটি, পুনৰাবৃত্তি ত্ৰুটি হাৰ (দৃঢ়তা), আৰু ত্ৰুটি শ্ৰেণীবিভাজন ট্ৰেক কৰে। নিম্ন ত্ৰুটি হাৰে ভাল জ্ঞানীয় কাৰ্য্য সূচায়।",
    mmseDefinition: "মিনি-মেন্টেল ষ্টেট পৰীক্ষা। এটা 30-বিন্দু প্ৰশ্নাৱলী যিয়ে অভিমুখীকৰণ (10), স্মৃতি (3), মনোযোগ (5), ভাষা (8), আৰু দৃশ্য-স্থানিক দক্ষতা (4) মূল্যায়ন কৰে। স্ক'ৰ: 24-30 (সাধাৰণ), 18-23 (মৃদু হানি), 0-17 (গুৰুতৰ হানি)।",
    mocaDefinition: "মণ্ট্ৰিয়েল জ্ঞানীয় মূল্যায়ন। মৃদু জ্ঞানীয় হানি সনাক্ত কৰে। মনোযোগ (6), কাৰ্যকাৰী কাৰ্য্য (5), স্মৃতি (5), ভাষা (6), দৃশ্য-স্থানিক দক্ষতা (5), আৰু অভিমুখীকৰণ (3) মূল্যায়ন কৰে। সাধাৰণ: ≥26, মৃদু হানি: 18-25, গুৰুতৰ: <18।",
    ace3Definition: "এডেনব্ৰুক জ্ঞানীয় পৰীক্ষা-III। ব্যাপক মূল্যায়ন যিয়ে মনোযোগ (18), স্মৃতি (26), প্ৰবাহ (14), ভাষা (26), আৰু দৃশ্য-স্থানিক ক্ষমতা (16) মূল্যায়ন কৰে। প্ৰাৰম্ভিক স্তৰৰ জ্ঞানীয় হ্ৰাসৰ প্ৰতি বিশেষভাৱে সংবেদনশীল।",
    minicogDefinition: "সংক্ষিপ্ত 3-মিনিট স্ক্ৰীণিং যিয়ে তিনিটা-আইটেম স্মৃতি (3 বিন্দু) ঘড়ী অংকন পৰীক্ষা (2 বিন্দু)ৰ সৈতে সংযুক্ত কৰে। ডিমেনচিয়া সনাক্ত কৰাত কাৰ্যকাৰী। স্ক'ৰ <3 জ্ঞানীয় হানিৰ ইংগিত দিয়ে।",
    slumsDefinition: "চেইণ্ট লুইছ বিশ্ববিদ্যালয় মানসিক স্থিতি পৰীক্ষা। মৃদু জ্ঞানীয় হানি আৰু ডিমেনচিয়া সনাক্ত কৰিবলৈ স্ক্ৰীণিং সঁজুলি। অভিমুখীকৰণ (4), স্মৃতি (5), মনোযোগ (5), কাৰ্যকাৰী কাৰ্য্য (6), আৰু ভাষা (10) মূল্যায়ন কৰে।",
    rudasDefinition: "ৰোলেণ্ড ইউনিভাৰ্ছেল ডিমেনচিয়া মূল্যায়ন স্কেল। সাংস্কৃতিক আৰু শিক্ষাগতভাৱে ন্যায়সঙ্গত জ্ঞানীয় স্ক্ৰীণিং যিয়ে স্মৃতি (8), শৰীৰ অভিমুখীকৰণ (6), প্ৰেক্সিছ (5), দৃশ্য-নিৰ্মাণ অংকন (4), সিদ্ধান্ত (4), আৰু ভাষা (3) মূল্যায়ন কৰে।",
    assessmentTools: "মূল্যায়ন সঁজুলি",
    assessmentToolsDefinition: "আমাৰ প্লেটফৰ্মে ছয়টা বৈধ জ্ঞানীয় স্ক্ৰীণিং সঁজুলি ব্যৱহাৰ কৰে: MMSE (অভিমুখীকৰণ, স্মৃতি, মনোযোগ), MoCA (মৃদু জ্ঞানীয় হানি সনাক্তকৰণ), ACE-III (ব্যাপক জ্ঞানীয় মূল্যায়ন), Mini-Cog (সংক্ষিপ্ত স্ক্ৰীণিং), SLUMS (ডিমেনচিয়া সনাক্তকৰণ), আৰু RUDAS (সাংস্কৃতিকভাৱে ন্যায়সঙ্গত মূল্যায়ন)।",
    benefits: "সুবিধা",
    benefit1: "সময়ৰ সৈতে ভাৱনাগত কল্যাণ ৰূপৰেখা মনিটৰ কৰক।",
    benefit2: "মানসিক স্বাস্থ্য মূল্যায়নৰ বাবে মানকীকৃত স্ক্ৰীণিং স্ক'ৰ (PHQ-9, GAD-7, GHQ) ট্ৰেক কৰক।",
    benefit3: "জ্ঞানীয় হানিৰ ঝুঁকিৰ নমুনা আৰু পৰিবৰ্তনসমূহ দৃশ্যত কৰক।",
    benefit4: "নমুনা চিনাক্ত কৰক আৰু ভাল কল্যাণৰ বাবে ডাটা-চালিত সিদ্ধান্ত লওক।",
    benefit5: "দৃশ্য ডাটা ব্যৱহাৰ কৰি স্বাস্থ্যৰক্ষা পেছাদাৰীসকলৰ সৈতে প্ৰগতি ভাগ-বতৰা কৰক।",
    usage: "কেনেকৈ ব্যৱহাৰ কৰিব",
    usageDescription: "ওপৰৰ ড্ৰপডাউন মেনুসমূহ ব্যৱহাৰ কৰি চাৰ্ট প্ৰকাৰ (বাৰ/লাইন) আৰু মেট্ৰিক শ্ৰেণী (ভাৱনাগত/স্ক্ৰীণিং/জ্ঞানীয়)ৰ মাজত সলনি কৰক। নৱীনতম ডাটাৰ সৈতে আপডেট কৰিবলৈ 'ৰিফ্ৰেছ' ক্লিক কৰক। বাৰ চাৰ্টে ব্যক্তিগত ডাটা বিন্দু দেখুৱায়, আনহাতে লাইন চাৰ্টে সময়ৰ সৈতে ৰূপৰেখা প্ৰদৰ্শন কৰে।",
    importantNotes: "গুৰুত্বপূৰ্ণ নোট",
    note1: "এই মেট্ৰিক্সসমূহ স্ক্ৰীণিং সঁজুলি, নিৰ্দেশনা সঁজুলি নহয়। চিকিৎসা পৰামৰ্শৰ বাবে সদায় স্বাস্থ্যৰক্ষা পেছাদাৰীসকলৰ সৈতে পৰামৰ্শ কৰক।",
    note2: "স্ক'ৰসমূহ পেছাদাৰী নিৰ্দেশনাৰ সৈতে প্ৰসংগত ব্যাখ্যা কৰা উচিত।",
    note3: "নিয়মীয়া মনিটৰিং (প্ৰতি 3-6 মাহত) পৰিবৰ্তন আৰু নমুনা ট্ৰেক কৰাত সহায় কৰে।",
    note4: "উচ্চ ঝুঁকিৰ স্ক'ৰে যোগ্য স্বাস্থ্যৰক্ষা পেছাদাৰীসকলৰ সৈতে পৰামৰ্শক উৎসাহিত কৰা উচিত।",
    languageNote: "ভাষা সমৰ্থন",
    languageDescription: "সকলো চাৰ্ট লেবেল আৰু বৰ্ণনা স্বয়ংক্ৰিয়ভাৱে আপোনাৰ নিৰ্বাচিত ভাষালৈ অভিযোজিত হয় যাতে এক সুসংগত ব্যৱহাৰকাৰী অভিজ্ঞতা পোৱা যায়।",
    insight: "অন্তৰ্দৃষ্টি",
    insightDescription: "এই মেট্ৰিক্সসমূহৰ বিশ্লেষণে নমুনা চিনাক্ত কৰাত, মানসিক চাপ পৰিচালনা কৰাত, আৰু ভাল কল্যাণৰ বাবে ডাটা-চালিত সিদ্ধান্ত ল'বলৈ সহায় কৰিব পাৰে।",
  },
  reminder: {
    title: "ৰিমাইণ্ডাৰ",
    message: "বাৰ্তা",
    when: "সময়",
    customOption: "নিজেই তাৰিখ/সময় নিৰ্বাচন কৰক",
    schedule: "ৰিমাইণ্ডাৰ ছেট কৰক",
    scheduling: "ৰিমাইণ্ডাৰ ছেট কৰি আছে...",
    scheduled: "ৰিমাইণ্ডাৰ সফলতাৰে ছেট হ'ল!",
    cancelled: "ৰিমাইণ্ডাৰ বাতিল কৰা হ'ল।",
    empty: "কোনো ৰিমাইণ্ডাৰ নাই।",
    invalidDate: "অনুগ্ৰহ কৰি বৈধ তাৰিখ আৰু সময় নিৰ্বাচন কৰক।",
    cancel: "বাতিল কৰক",
    manage: "ৰিমাইণ্ডাৰ ব্যৱস্থাপনা কৰক",
    fetchError: "ৰিমাইণ্ডাৰ আহৰণ কৰোঁতে ত্ৰুটি।",
    scheduleError: "ৰিমাইণ্ডাৰ ছেট কৰিব পৰা নগ'ল।",
    cancelError: "ৰিমাইণ্ডাৰ বাতিল কৰিব পৰা নগ'ল।",
    defaultMessage: "মৈত্ৰীৰ পৰা এখন স্মৰণীয় বাৰ্তা",
    presets: {
      "1day": "১ দিনত",
      "2day": "২ দিনত",
      "3day": "৩ দিনত",
      "1week": "১ সপ্তাহত"
    },
    quickAddPlaceholder: "দ্রুত ৰিমাইণ্ডাৰ যোগ কৰক...",
    predefinedMessages: {
      takeMedicine: "ঔষধ খাওক",
      doctorAppointment: "ডাক্তৰৰ এপইণ্টমেন্ট",
      exercise: "ব্যায়াম",
      drinkWater: "পানী খাওক"
    },
    repeat: {
      none: "একবাৰ",
      daily: "দৈনিক",
      weekly: "সাপ্তাহিক",
      monthly: "মাসিক",
      custom: "কাষ্টম অন্তৰাল"
    },
    addQuickReminder: "দ্রুত ৰিমাইণ্ডাৰ যোগ কৰক",
    reminderMessagePlaceholder: "ৰিমাইণ্ডাৰ বাৰ্তা",
    emailPlaceholder: "আপোনাৰ ই-মেইল",
    selectDateTime: "তাৰিখ আৰু সময় নিৰ্বাচন কৰক",
    time: "সময়",
    optionalEndDate: "ঐচ্ছিক শেষ তাৰিখ",
    selected: "নিৰ্বাচিত:",
    processing: "প্ৰক্ৰিয়াকৰণ...",
    addReminder: "ৰিমাইণ্ডাৰ যোগ কৰক",
    stats: "পৰিসংখ্যা",
    totalReminders: "মুঠ ৰিমাইণ্ডাৰ",
    dailyReminders: "দৈনিক ৰিমাইণ্ডাৰ",
    weeklyReminders: "সাপ্তাহিক ৰিমাইণ্ডাৰ",
    monthlyReminders: "মাসিক ৰিমাইণ্ডাৰ",
    nextReminder: "পৰৱৰ্তী ৰিমাইণ্ডাৰ",
    allRepeats: "সকলো পুনৰাবৃত্তি",
    byEmail: "ই-মেইলৰ দ্বাৰা",
    byMessage: "বাৰ্তাৰ দ্বাৰা",
    searchPlaceholder: "ৰিমাইণ্ডাৰ সন্ধান কৰক...",
    emailLabel: "ই-মেইল:",
    dateTimeLabel: "তাৰিখ আৰু সময়:",
    repeatLabel: "পুনৰাবৃত্তি:",
    intervalLabel: "অন্তৰাল:",
    endsLabel: "শেষ:",
    statusLabel: "স্থিতি:",
    delete: "মচক",
    loadingReminders: "ৰিমাইণ্ডাৰ লোড হৈ আছে...",
    noReminders: "এখনো ৰিমাইণ্ডাৰ নাই।",
    benefitsTitle: "ডিমেনচিয়া ৰোগীৰ বাবে সুবিধা",
    benefitsText1: "নিয়মিত ৰিমাইণ্ডাৰে ডিমেনচিয়া ৰোগীক দৈনন্দিন ৰুটিন ৰাখিবলৈ, বিভ্ৰান্তি কমাবলৈ আৰু স্মৃতি ৰাখিবলৈ সহায় কৰে।",
    benefitsText2: "ঔষধ, এপইণ্টমেন্ট আৰু দৈনন্দিন কাৰ্যকলাপৰ বাবে সময়সূচীভুক্ত এলাৰ্টে গঠন প্ৰদান কৰে, স্বাধীনতাক উৎসাহিত কৰে আৰু উদ্বেগ কমায়।",
    allFieldsRequired: "সকলো ক্ষেত্ৰ আবশ্যক।",
    validDateTimeRequired: "অনুগ্ৰহ কৰি বৈধ তাৰিখ আৰু সময় নিৰ্বাচন কৰক।",
    failedToAdd: "ৰিমাইণ্ডাৰ যোগ কৰাত ব্যৰ্থ।",
    confirmDelete: "আপুনি নিশ্চিত যে আপুনি এই ৰিমাইণ্ডাৰটো মচিব বিচাৰে?",
    failedToDelete: "ৰিমাইণ্ডাৰ মচাত ব্যৰ্থ।",
    quickAddRequired: "দ্রুত যোগ কৰাৰ বাবে বাৰ্তা আৰু ই-মেইল আবশ্যক।",
    failedQuickAdd: "দ্রুত ৰিমাইণ্ডাৰ যোগ কৰাত ব্যৰ্থ।",
    none: "কোনো নাই"
  },
  dementia: {
    title: "ডিমেনচিয়া চেকাৰ",
    start: "আৰম্ভ কৰক",
    starting: "আৰম্ভ হৈছে...",
    timeLeft: "অৱশিষ্ট সময়: {{seconds}} ছেকেণ্ড",
    intro: "৫–৬ সময়-সীমিত প্ৰশ্ন আহৰণ কৰিবলৈ 'আৰম্ভ কৰক' ক্লিক কৰক। সময় শেষ হ'লে, খালি উত্তৰ স্বয়ংক্ৰিয়ভাৱে সংৰক্ষিত হব।",
    placeholder: "আপোনাৰ উত্তৰ লিখক...",
    next: "পৰৱৰ্তী",
    submit: "জমা দিয়ক",
    progress: "প্ৰশ্ন {{current}} / {{total}}",
    draftTitle: "খচৰা উত্তৰ (স্থানীয়)",
    emptyAnswer: "(খালি)",
    record: "ৰেকৰ্ড",
    stopRecording: "ৰেকৰ্ডিং বন্ধ কৰক",
    recording: "ৰেকৰ্ডিং...",
    preview: "পূৰ্বদৰ্শন",
    hasAudio: "অডিঅ'সহ",
    questionHidden: "প্ৰশ্ন লুকুৱা আছে। তলত আপোনাৰ উত্তৰ লিখক।",
    moderate: "মধ্যম",
    category: "শ্ৰেণী",
    failedToLoadQuestions: "প্ৰশ্ন লোড কৰাত ব্যৰ্থ। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    failedToStart: "পৰীক্ষা আৰম্ভ কৰাত ব্যৰ্থ। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    microphonePermissionDenied: "মাইক্ৰ'ফোন অনুমতি অস্বীকৃত। অনুগ্ৰহ কৰি অডিঅ' ৰেকৰ্ড কৰিবলৈ মাইক্ৰ'ফোন প্ৰৱেশাধিকাৰ অনুমোদন দিয়ক।",
    submissionError: "উত্তৰ জমা দিয়াত ব্যৰ্থ। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    games: {
      clockTest: "ঘড়ী পৰীক্ষা",
      colorSequence: "ৰং ক্ৰম",
      matchingCards: "মিলা কাৰ্ড",
      textRecall: "টেক্সট ৰিকল",
      reactionTime: "প্ৰতিক্ৰিয়া সময়",
      numberOrder: "সংখ্যা ক্ৰম",
      wordMemory: "শব্দ স্মৃতি",
      stroopTest: "ষ্ট্ৰুপ টেষ্ট",
      patternGrid: "পেটাৰ্ণ গ্ৰিড",
      symbolMatch: "চিহ্ন মিল",
      oddColor: "বিষম ৰং",
      digitSpan: "অংক স্পেন",
      nBack: "এন-বেক",
      memory: "স্মৃতি মিল",
      patternRecall: "পেটাৰ্ণ ৰিকল",
      descriptions: {
        clockTest: "সময় সঠিকভাৱে চিনাক্ত কৰক আৰু ছেট কৰক। সময় সচেতনতা আৰু দৃশ্য-স্থানিক প্ৰক্ৰিয়াকৰণ পৰীক্ষা কৰে।",
        colorSequence: "ৰং ক্ৰম মনত ৰাখক আৰু ক্ৰম অনুসৰি পুনৰাবৃত্তি কৰক। কাৰ্যকৰী স্মৃতি আৰু ক্ৰমিক প্ৰক্ৰিয়াকৰণ পৰীক্ষা কৰে।",
        matchingCards: "কাৰ্ডৰ স্থান মনত ৰাখি যোৰ মিলাওক। দৃশ্য স্মৃতি আৰু স্মৰণ ক্ষমতা মূল্যায়ন কৰে।",
        textRecall: "সময়ৰ চাপত পাঠ পঢ়ক আৰু মনত ৰাখক। মৌখিক স্মৃতি আৰু বুজাবুজি মূল্যায়ন কৰে।",
        reactionTime: "দৃশ্য উদ্দীপনাত দ্ৰুত সঁহাৰি দিয়ক। প্ৰক্ৰিয়াকৰণ গতি আৰু মনোযোগ জোখে।",
        numberOrder: "সংখ্যা ক্ৰম মনত ৰাখক আৰু স্মৰণ কৰক। চমু-ম্যাদী স্মৃতি আৰু সংখ্যাগত প্ৰক্ৰিয়াকৰণ পৰীক্ষা কৰে।",
        wordMemory: "শব্দ তালিকা মুখস্থ কৰক আৰু স্মৰণ কৰক। মৌখিক স্মৃতি আৰু ধাৰণ ক্ষমতা মূল্যায়ন কৰে।",
        stroopTest: "বিৰোধী পাঠ ৰং উপেক্ষা কৰি ৰং নাম চিনাক্ত কৰক। জ্ঞানীয় নমনীয়তা আৰু নিষেধাজ্ঞা মূল্যায়ন কৰে।",
        patternGrid: "গ্ৰিডত দৃশ্য পেটাৰ্ণ মনত ৰাখক আৰু পুনৰ নিৰ্মাণ কৰক। স্থানিক স্মৃতি আৰু দৃশ্য প্ৰক্ৰিয়াকৰণ পৰীক্ষা কৰে।",
        symbolMatch: "চিহ্ন আৰু পেটাৰ্ণ মিলাওক। পেটাৰ্ণ চিনাক্তকৰণ আৰু দৃশ্য-স্থানিক দক্ষতা মূল্যায়ন কৰে।",
        oddColor: "একে ধৰণৰ বস্তুৰ মাজত বেলেগ ৰঙৰ বস্তু চিনাক্ত কৰক। বিৱৰণৰ প্ৰতি মনোযোগ আৰু দৃশ্য বৈষম্য পৰীক্ষা কৰে।",
        digitSpan: "অংকৰ ক্ৰম মনত ৰাখক আৰু স্মৰণ কৰক। কাৰ্যকৰী স্মৃতি ক্ষমতা আৰু মনোযোগ পৰীক্ষা কৰে।",
        nBack: "এটা ক্ৰমত N পদক্ষেপ পিছত দেখা দিয়া বস্তু চিনাক্ত কৰক। কাৰ্যকৰী স্মৃতি আৰু কাৰ্যকাৰী কাৰ্য পৰীক্ষা কৰে।",
        memory: "স্মৃতিৰ পৰা কাৰ্ডৰ যোৰ মিলাওক। দৃশ্য স্মৃতি, পেটাৰ্ণ চিনাক্তকৰণ আৰু স্মৰণ ক্ষমতা মূল্যায়ন কৰে।",
        patternRecall: "ৰং ক্ৰম চাওক আৰু একে ক্ৰমত পুনৰাবৃত্তি কৰক। কাৰ্যকৰী স্মৃতি, ক্ৰমিক প্ৰক্ৰিয়াকৰণ আৰু পেটাৰ্ণ চিনাক্তকৰণ ক্ষমতা মূল্যায়ন কৰে।"
      },
      benefits: {
        clockTest: "সময় সচেতনতা আৰু দৃশ্য-স্থানিক দক্ষতা মূল্যায়ন কৰে, যি ডিমেনচিয়া ৰোগীত প্ৰায়ে বেয়া হয়।",
        colorSequence: "স্মৃতি হ্ৰাস আৰু কাৰ্যকাৰী কাৰ্য হানিৰ প্ৰাৰম্ভিক লক্ষণ চিনাক্ত কৰাত সহায় কৰে।",
        matchingCards: "ডিমেনচিয়াৰ সাধাৰণ দৃশ্য স্মৃতি ঘাটতি আৰু স্থানিক প্ৰক্ৰিয়াকৰণ সমস্যা চিনাক্ত কৰে।",
        textRecall: "মৌখিক স্মৃতি সমস্যা আৰু ভাষা বুজাবুজিৰ অসুবিধা প্ৰকাশ কৰে।",
        reactionTime: "ধীৰ জ্ঞানীয় প্ৰক্ৰিয়াকৰণ চিনাক্ত কৰে, যি জ্ঞানীয় হ্ৰাসৰ প্ৰাৰম্ভিক সূচক।",
        numberOrder: "কাৰ্যকৰী স্মৃতি ক্ষমতা মূল্যায়ন কৰে, যি ডিমেনচিয়াৰ প্ৰাৰম্ভিক স্তৰত প্ৰায়ে প্ৰভাৱিত হয়।",
        wordMemory: "মৌখিক স্মৃতি ধাৰণ মূল্যায়ন কৰে, যি স্মৃতি-সম্পৰ্কীয় জ্ঞানীয় সমস্যা চিনাক্ত কৰাৰ বাবে গুৰুত্বপূৰ্ণ।",
        stroopTest: "কাৰ্যকাৰী কাৰ্য আৰু জ্ঞানীয় নিয়ন্ত্ৰণ জোখে, যি ডিমেনচিয়া ৰোগীত বেয়া হয়।",
        patternGrid: "স্থানিক স্মৃতি আৰু দৃশ্য প্ৰক্ৰিয়াকৰণ পৰীক্ষা কৰে, যি ডিমেনচিয়াৰ দ্বাৰা প্ৰায়ে প্ৰভাৱিত হয়।",
        symbolMatch: "পেটাৰ্ণ চিনাক্তকৰণ ক্ষমতা মূল্যায়ন কৰে, যি জ্ঞানীয় হানিৰ সৈতে হ্ৰাস পায়।",
        oddColor: "মনোযোগ আৰু দৃশ্য বৈষম্য মূল্যায়ন কৰে, দক্ষতা যি ডিমেনচিয়াত বেয়া হয়।",
        digitSpan: "কাৰ্যকৰী স্মৃতি স্পেন জোখে, যি জ্ঞানীয় স্বাস্থ্য আৰু প্ৰাৰম্ভিক ডিমেনচিয়া লক্ষণৰ এক গুৰুত্বপূৰ্ণ সূচক।",
        nBack: "কাৰ্যকৰী স্মৃতি আৰু কাৰ্যকাৰী নিয়ন্ত্ৰণ মূল্যায়ন কৰে, যি জ্ঞানীয় হ্ৰাসৰ দ্বাৰা প্ৰভাৱিত গুৰুত্বপূৰ্ণ কাৰ্য।",
        memory: "দৃশ্য স্মৃতি আৰু পেটাৰ্ণ চিনাক্তকৰণ পৰীক্ষা কৰে, অত্যাৱশ্যকীয় দক্ষতা যি ডিমেনচিয়া প্ৰগতিৰ সৈতে বেয়া হয়।",
        patternRecall: "ক্ৰমিক স্মৃতি আৰু কাৰ্যকৰী স্মৃতি ক্ষমতা মূল্যায়ন কৰে, গুৰুত্বপূৰ্ণ জ্ঞানীয় কাৰ্য যি প্ৰাৰম্ভিক-স্তৰৰ ডিমেনচিয়াত হ্ৰাস পায়। স্মৃতি এনকোডিং আৰু পুনৰুদ্ধাৰ ঘাটি চিনাক্ত কৰাত সহায় কৰে।"
      }
    },
    completed: "সম্পূৰ্ণ",
    play: "খেলক",
    completedCount: "সম্পূৰ্ণ {{count}} / ৫",
    calculating: "গণনা কৰি আছে...",
    viewResults: "ফলাফল চাওক",
    reset: "ৰিচেট",
    riskAssessmentResults: "ঝুঁকি মূল্যায়ন ফলাফল",
    calculatingAssessment: "আপোনাৰ ঝুঁকি মূল্যায়ন গণনা কৰি আছে...",
    riskScore: "ঝুঁকি স্ক'ৰ",
    riskLevel: "ঝুঁকি স্তৰ",
    averageScore: "গড় স্ক'ৰ",
    averageTime: "গড় সময়",
    explanation: "ব্যাখ্যা",
    suggestions: "পৰামৰ্শ",
    gameResultsSummary: "খেলাৰ ফলাফল সাৰাংশ",
    failedAssessment: "ঝুঁকি মূল্যায়ন গণনা কৰাত ব্যৰ্থ। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    score: "স্ক'ৰ",
    time: "সময়",
    howItHelps: "ই কেনেকৈ সহায় কৰে:",
    testCompleted: "পৰীক্ষা সম্পূৰ্ণ!",
    saveContinue: "সংৰক্ষণ কৰক আৰু অব্যাহত ৰাখক",
    close: "বন্ধ কৰক",
    exit: "ওলাই যাওক",
    backToGames: "খেলসমূহলৈ উভতি যাওক",
    points: "পইণ্ট",
    totalTime: "মুঠ সময়",
    rounds: "ৰাউণ্ড",
    attempts: "চেষ্টা",
    accuracy: "নিৰ্ভুলতা",
    errors: "ভুল",
    round: "ৰাউণ্ড",
    selectDifficulty: "কঠিনতা নিৰ্বাচন কৰক:",
    easy: "সহজ",
    medium: "মধ্যম",
    hard: "কঠিন",
    submit: "জমা দিয়ক",
    submitAnswer: "উত্তৰ জমা দিয়ক",
    next: "পৰৱৰ্তী",
    timer: "টাইমাৰ",
    digits: "অংক",
    performance: {
      excellent: "উৎকৃষ্ট কাৰ্যক্ষমতা!",
      good: "ভাল কাৰ্যক্ষমতা!",
      fair: "যথেষ্ট কাৰ্যক্ষমতা!",
      practice: "অভ্যাস অব্যাহত ৰাখক!"
    },
    performanceDesc: {
      excellent: "উৎকৃষ্ট জ্ঞানীয় কাৰ্যক্ষমতা! ভাল কাম অব্যাহত ৰাখক।",
      good: "দৃঢ় কাৰ্যক্ষমতা! আপুনি আপোনাৰ জ্ঞানীয় অনুশীলনত ভাল কৰি আছে।",
      fair: "ভাল চেষ্টা! নিয়মিত অনুশীলনে আপোনাৰ স্ক'ৰ উন্নত কৰাত সহায় কৰিব।",
      practice: "হাৰ নিদিব! উন্নতি দেখিবলৈ নিয়মিতভাৱে অনুশীলন কৰক।"
    },
    confirmReset: "আপুনি নিশ্চিতভাৱে সকলো অগ্ৰগতি ৰিচেট কৰিব বিচাৰে?",
    needMoreGames: "অনুগ্ৰহ কৰি ফলাফল চাবলৈ কমেও {{count}} খেল সম্পূৰ্ণ কৰক।",
    gamesRemaining: "{{count}} অধিক",
    gamesRemainingText: "খেলৰ প্ৰয়োজন",
    emailSent: "ৰিপ'ৰ্ট আপোনাৰ ই-মেইললৈ সফলতাৰে পঠিওৱা হ'ল!",
    emailFailed: "ই-মেইল পঠিওৱা নগ'ল, কিন্তু আপোনাৰ ৰিপ'ৰ্ট তলত উপলব্ধ।",
    networkError: "নেটৱৰ্ক সংযোগ ত্ৰুটি। অনুগ্ৰহ কৰি আপোনাৰ ইণ্টাৰনেট সংযোগ পৰীক্ষা কৰক আৰু পুনৰ চেষ্টা কৰক।",
    gameError: "খেল লোড কৰোতে এটা ত্ৰুটি ঘটিল।",
    domainMemory: "মেমৰি",
    domainLanguage: "ভাষা",
    domainAttention: "মনোযোগ",
    domainOrientation: "অভিমুখীকৰণ",
    domainExecutive: "কাৰ্যকাৰী",
    cognitiveDomains: "জ্ঞানীয় ড'মেইন স্ক'ৰ",
    weightedRiskScore: "ভাৰযুক্ত ঝুঁকি স্ক'ৰ",
    howScoringWorks: "ফলাফল কেনেকৈ স্ক'ৰ আৰু মূল্যায়ন কৰা হয়",
    gameBasedScoring: "গেম-ভিত্তিক মূল্যায়ন স্ক'ৰিং",
    cognitiveScoringExplanation: "জ্ঞানীয় মেট্ৰিক্স বিভিন্ন জ্ঞানীয় গেমত আপোনাৰ কাৰ্য্যক্ষমতাৰ পৰা গণনা কৰা হয়। প্ৰতিটো গেম বৈধ নিউৰ'সাইক'লজিকেল পৰীক্ষাৰ প্ৰতিমানৰ ওপৰত ভিত্তি কৰি নিৰ্দিষ্ট জ্ঞানীয় ড'মেইন মূল্যায়ন কৰিবলৈ ডিজাইন কৰা হৈছে। প্ৰতিটো গেমৰ পৰা আপোনাৰ কেঁচা স্ক'ৰ ন্যায়সঙ্গত তুলনা নিশ্চিত কৰিবলৈ কঠিনতাৰ স্তৰ (সহজ, মধ্যম, কঠিন)ৰ দ্বাৰা স্বাভাৱিকীকৃত কৰা হয়। ব্যৱহৃত সূত্ৰ হ'ল: স্বাভাৱিকীকৃত স্ক'ৰ = (কেঁচা স্ক'ৰ / কঠিনতাৰ বাবে সৰ্বোচ্চ সম্ভৱ স্ক'ৰ) × 100। এই স্বাভাৱিকীকৰণে বিভিন্ন কঠিনতা গুণক (সহজ: 1.0x, মধ্যম: 1.5x, কঠিন: 2.0x) বিবেচনা কৰে আৰু নিশ্চিত কৰে যে স্ক'ৰবোৰ গেম আৰু কঠিনতাৰ স্তৰত তুলনাযোগ্য।",
    domainMapping: "গেম-থেকে-ড'মেইন মেপিং",
    domainMappingExplanation: "প্ৰতিটো গেম নৈদানিক ন্যায়সঙ্গততাৰ সৈতে নিৰ্দিষ্ট জ্ঞানীয় ড'মেইনলৈ মেপ কৰে: ডিজিট স্পেন আৰু N-Back প্ৰধানকৈ মেমৰি (কাৰ্য্যক্ষম মেমৰি ক্ষমতা) পৰীক্ষা কৰে। পেটাৰ্ণ ৰিকল আৰু মেমৰি মেচে মেমৰি আৰু মনোযোগ মূল্যায়ন কৰে। ৰিয়েকশন টাইমে মনোযোগ আৰু প্ৰসংসকৰণ গতি মাপে। ষ্ট্ৰুপ টেষ্টে কাৰ্যকাৰী কাৰ্য্য (জ্ঞানীয় নমনীয়তা আৰু নিষেধ) মূল্যায়ন কৰে। ক্লক ড্ৰইংয়ে কাৰ্যকাৰী কাৰ্য্য, অভিমুখীকৰণ, আৰু দৃশ্য-স্থানিক ক্ষমতা পৰীক্ষা কৰে। টেক্স্ট ৰিকল (ডিমেনচিয়া চেকাৰ) মেমৰি আৰু ভাষা মূল্যায়ন কৰে। প্ৰতিটো গেমে ভাৰযুক্ত গুৰুত্বৰ সৈতে ড'মেইন স্ক'ৰলৈ অৱদান আগবঢ়ায় যি এইটোৰ ওপৰত ভিত্তি কৰি যে ই প্ৰধানকৈ কোনটো জ্ঞানীয় কাৰ্য্য পৰীক্ষা কৰে।",
    weightedRiskCalculation: "ভাৰযুক্ত ঝুঁকি স্ক'ৰ গণনা",
    weightedRiskExplanation: "চূড়ান্ত জ্ঞানীয় ঝুঁকি স্ক'ৰে নৈদানিক গৱেষণাৰ ওপৰত ভিত্তি কৰি ভাৰযুক্ত ড'মেইন মডেল ব্যৱহাৰ কৰে: মেমৰি (30% ভাৰ) - মুখ্য প্ৰাৰম্ভিক ডিমেনচিয়া চিহ্ন, ভাষা (20%) - শব্দ-খোঁজাৰ সমস্যা প্ৰাৰম্ভিকতে দেখা যায়, মনোযোগ (20%) - কাৰ্যকাৰী হ্ৰাসে মনোযোগ নেটৱৰ্কক প্ৰভাৱিত কৰে, অভিমুখীকৰণ (15%) - মধ্যম প্ৰভাৱ, কাৰ্যকাৰী কাৰ্য্য (15%) - গুৰুত্বপূৰ্ণ কিন্তু সাধাৰণতে পিছৰ স্তৰৰ চিহ্ন। সূত্ৰে গণনা কৰে: ভাৰযুক্ত ঝুঁকি স্ক'ৰ = Σ(ড'মেইন ঝুঁকি × ড'মেইন ভাৰ), য'ত ড'মেইন ঝুঁকি = 1 - (ড'মেইন স্ক'ৰ / 10)। উচ্চ ড'মেইন স্ক'ৰ (0-10 স্কেল) ভাল জ্ঞানীয় কাৰ্য্য সূচায়, ফলত নিম্ন ঝুঁকি স্ক'ৰ (0-1 স্কেল) হয়। ঝুঁকিৰ স্তৰ নিৰ্ধাৰণ কৰা হয়: উচ্চ (≥70%), মধ্যম (40-69%), নিম্ন (<40%)।",
    whatEachGameTests: "প্ৰতিটো গেমে কি পৰীক্ষা কৰে",
    digitSpanGame: "ডিজিট স্পেন",
    digitSpanGameDesc: "আপোনাক অংকৰ ক্ৰম স্মৰণ ৰাখিবলৈ আৰু স্মৰণ কৰিবলৈ প্ৰয়োজন কৰি কাৰ্য্যক্ষম মেমৰি ক্ষমতা পৰীক্ষা কৰে। তাৎক্ষণিক মেমৰি স্পেন মাপে, যি জ্ঞানীয় স্বাস্থ্যৰ এটা মুখ্য সূচক। প্ৰাৰম্ভিক আলঝেইমাৰ ৰোগে চমু-ম্যাদী স্মৰণক প্ৰভাৱিত কৰে, যিয়ে এই পৰীক্ষাক প্ৰাৰম্ভিক জ্ঞানীয় হ্ৰাসৰ প্ৰতি সংবেদনশীল কৰি তোলে।",
    nBackGame: "N-Back",
    nBackGameDesc: "আপোনাক এটা ক্ৰমত N পদক্ষেপ পিছত দেখা দিয়া আইটেমবোৰ চিনাক্ত কৰিবলৈ প্ৰয়োজন কৰি কাৰ্য্যক্ষম মেমৰি আৰু কাৰ্যকাৰী কাৰ্য্য মূল্যায়ন কৰে। কাৰ্য্যক্ষম মেমৰিত তথ্য ৰাখিবলৈ আৰু আপডেট কৰিবলৈ আপোনাৰ ক্ষমতা পৰীক্ষা কৰে, যি মৃদু জ্ঞানীয় হানি (MCI) হ্ৰাসৰ প্ৰতি সংবেদনশীল।",
    patternRecallGame: "পেটাৰ্ণ ৰিকল",
    patternRecallGameDesc: "আপোনাক দৃশ্য পেটাৰ্ণ স্মৰণ ৰাখিবলৈ আৰু পুনৰ উৎপাদন কৰিবলৈ প্ৰয়োজন কৰি দৃশ্য মেমৰি আৰু ক্ৰমিক প্ৰসংসকৰণ পৰীক্ষা কৰে। মেমৰি এনকোডিং আৰু পুনৰুদ্ধাৰ ঘাটি মূল্যায়ন কৰে, যি গুৰুত্বপূৰ্ণ জ্ঞানীয় কাৰ্য্য যি প্ৰাৰম্ভিক-স্তৰৰ ডিমেনচিয়াত হ্ৰাস পায়।",
    memoryMatchGame: "মেমৰি মেচ",
    memoryMatchGameDesc: "আপোনাক তেওঁলোকৰ স্থান স্মৰণ ৰাখি কাৰ্ডৰ যোৰ মিলাবলৈ প্ৰয়োজন কৰি সহযোগী মেমৰি মূল্যায়ন কৰে। হিপ্পোকেম্পেল-নিৰ্ভৰশীল মেমৰি চিস্টেম পৰীক্ষা কৰে, যি প্ৰাৰম্ভিক আলঝেইমাৰ ৰোগত দৃঢ়তাৰে প্ৰভাৱিত হয়। দৃশ্য মেমৰি ঘাটি আৰু স্থানিক প্ৰসংসকৰণ সমস্যা চিনাক্ত কৰে।",
    reactionTimeGame: "ৰিয়েকশন টাইম",
    reactionTimeGameDesc: "দৃশ্য উদ্দীপনাৰ বাবে দ্ৰুত প্ৰতিক্ৰিয়াৰ প্ৰয়োজন কৰি প্ৰসংসকৰণ গতি আৰু মনোযোগ মাপে। ধীৰ জ্ঞানীয় প্ৰসংসকৰণ সনাক্ত কৰে, যি জ্ঞানীয় হ্ৰাসৰ এটা প্ৰাৰম্ভিক সূচক। গড় প্ৰতিক্ৰিয়া সময়, পৰিৱৰ্তনশীলতা, আৰু আটাইতকৈ ধীৰ 10% প্ৰতিক্ৰিয়া ট্ৰেক কৰে।",
    colorSequenceGame: "ৰং ক্ৰম",
    colorSequenceGameDesc: "আপোনাক ক্ৰমত ৰং ক্ৰম স্মৰণ ৰাখিবলৈ আৰু পুনৰাবৃত্তি কৰিবলৈ প্ৰয়োজন কৰি ক্ৰমিক মেমৰি পৰীক্ষা কৰে। কাৰ্য্যক্ষম মেমৰি আৰু কাৰ্যকাৰী কাৰ্য্য উপাদান মূল্যায়ন কৰে যি প্ৰাৰম্ভিক ডিমেনচিয়াত প্ৰভাৱিত হয়। মেমৰিত ক্ৰম ৰাখিবলৈ ক্ষমতা মাপে।",
    stroopTestGame: "ষ্ট্ৰুপ টেষ্ট",
    stroopTestGameDesc: "আপোনাক বিৰোধী পাঠ ৰং উপেক্ষা কৰি ৰং নাম চিনাক্ত কৰিবলৈ প্ৰয়োজন কৰি জ্ঞানীয় নমনীয়তা আৰু নিষেধ মূল্যায়ন কৰে। কাৰ্যকাৰী কাৰ্য্য আৰু জ্ঞানীয় নিয়ন্ত্ৰণ মাপে, যি ডিমেনচিয়া ৰোগীত ক্ষতিগ্ৰস্ত হয়। স্বয়ংক্ৰিয় প্ৰতিক্ৰিয়া নিষেধ কৰিবলৈ ক্ষমতা পৰীক্ষা কৰে।",
    clockDrawingGame: "ক্লক ড্ৰইং",
    clockDrawingGameDesc: "ডিমেনচিয়াৰ বাবে ব্যাপকভাৱে ব্যৱহৃত স্ক্ৰীণিং সঁজুলি যি দৃশ্য-স্থানিক দক্ষতা, কাৰ্যকাৰী কাৰ্য্য, মনোযোগ, আৰু শব্দাৰ্থিক মেমৰি অন্তৰ্ভুক্ত কৰি কেইবাটাও জ্ঞানীয় ড'মেইন মূল্যায়ন কৰে। এইটো এটা নৈদানিকভাৱে বৈধ পৰীক্ষা (CDT) যি MMSE, MoCA, আৰু অন্যান্য মূল্যায়নত ব্যৱহৃত হয়। ক্লক ড্ৰইংত হানি জ্ঞানীয় হ্ৰাসৰ শক্তিশালী সূচক।",
    textRecallGame: "টেক্স্ট ৰিকল",
    textRecallGameDesc: "আপোনাক পাঠ অংশ পঢ়িবলৈ আৰু স্মৰণ কৰিবলৈ প্ৰয়োজন কৰি মেমৰি আৰু ভাষা মূল্যায়ন কৰে। মৌখিক মেমৰি, ভাষা বুজাবুজি, আৰু ধাৰণ ক্ষমতা পৰীক্ষা কৰে। প্ৰাৰম্ভিক আলঝেইমাৰৰ বৈশিষ্ট্যত মেমৰি আৰু ভাষা ঘাটি অন্তৰ্ভুক্ত, যিয়ে এই পৰীক্ষাক প্ৰাৰম্ভিক সনাক্তকৰণৰ বাবে অতি প্ৰাসংগিক কৰি তোলে।",
    primaryDomain: "প্ৰাথমিক ড'মেইন",
    secondaryDomain: "দ্বিতীয়",
    importantDisclaimer: "গুৰুত্বপূৰ্ণ অস্বীকৃতি",
    disclaimerTitle: "মূল্যায়ন উদ্দেশ্য",
    disclaimerText1: "এই জ্ঞানীয় মূল্যায়নবোৰ কেৱল স্ক্ৰীণিং আৰু আত্ম-মূল্যায়ন উদ্দেশ্যৰ বাবে ডিজাইন কৰা হৈছে। এইবোৰ বৈধ নিউৰ'সাইক'লজিকেল পৰীক্ষাৰ প্ৰতিমানৰ ওপৰত ভিত্তি কৰি কিন্তু পেছাদাৰী চিকিৎসা মূল্যায়ন, নিৰ্দেশনা, বা চিকিৎসা প্ৰতিস্থাপন কৰিবলৈ উদ্দেশ্য নহয়।",
    disclaimerTitle2: "নৈদানিক ব্যাখ্যা",
    disclaimerText2: "ফলাফলবোৰ যোগ্য স্বাস্থ্যৰক্ষা পেছাদাৰীসকলে ব্যাপক নৈদানিক মূল্যায়ন, চিকিৎসা ইতিহাস, আৰু উপযুক্ত নৈদানিক পৰীক্ষাৰ সৈতে মিলি ব্যাখ্যা কৰা উচিত। স্ক'ৰবোৰ ক্লান্তি, মানসিক চাপ, ঔষধৰ প্ৰভাৱ, বা অস্থায়ী স্বাস্থ্য অৱস্থাৰ দৰে কাৰকৰ দ্বাৰা প্ৰভাৱিত হ'ব পাৰে।",
    disclaimerTitle3: "নিৰ্দেশনা নহয়",
    disclaimerText3: "প্লেটফৰ্মে চিকিৎসা নিৰ্দেশনা, চিকিৎসা পৰামৰ্শ, বা নৈদানিক সিদ্ধান্ত-গ্ৰহণ সহায়তা প্ৰদান নকৰে। যিকোনো চিকিৎসা উদ্বেগ বা স্বাস্থ্য-সম্পৰ্কীয় সিদ্ধান্ত লোৱাৰ আগতে সদায় লাইচেন্সযুক্ত স্বাস্থ্যৰক্ষা পেছাদাৰীসকলৰ সৈতে পৰামৰ্শ কৰক।",
    assessmentMethodology: "মূল্যায়ন পদ্ধতি",
    methodologyText: "স্ক'ৰ ভাৰযুক্ত জ্ঞানীয় ড'মেইন মডেল ব্যৱহাৰ কৰি গণনা কৰা হয়। গেমবোৰে নৈদানিক ন্যায়সঙ্গততাৰ সৈতে নিৰ্দিষ্ট জ্ঞানীয় ড'মেইন (মেমৰি, ভাষা, মনোযোগ, অভিমুখীকৰণ, কাৰ্যকাৰী)লৈ মেপ কৰে। ন্যায়সঙ্গত তুলনাৰ বাবে কঠিনতাৰ স্তৰৰ দ্বাৰা স্ক'ৰ স্বাভাৱিকীকৃত কৰা হয়।",
    errorMessage: "কিবা ভুল হ'ল। অনুগ্ৰহ কৰি পৃষ্ঠাটো ৰিফ্ৰেছ কৰক।",
    loadingGames: "খেলাবোৰ ল'ড হৈছে...",
    errorLoadingGames: "খেলা ল'ড কৰাত ত্ৰুটি",
    refreshPage: "পৃষ্ঠা ৰিফ্ৰেছ কৰক",
    gamesCompleted: "খেলা সম্পূৰ্ণ",
    game: "খেলা",
    ageGroup: "বয়সৰ গোট",
    subtitle: "বৈজ্ঞানিকভাৱে ডিজাইন কৰা জ্ঞানীয় মূল্যায়নৰ সৈতে জড়িত হ'ক যিয়ে স্মৃতি, মনোযোগ, ভাষা, আৰু কাৰ্যকাৰী দক্ষতাৰ দৰে মূল মানসিক কাৰ্য্যবোৰ মূল্যায়ন কৰে। ব্যাপক AI-চালিত ঝুঁকি মূল্যায়ন আৰু আপোনাৰ জ্ঞানীয় স্বাস্থ্যত ব্যক্তিগত অন্তৰ্দৃষ্টি পাবলৈ একাধিক খেলা সম্পূৰ্ণ কৰক।",
    importantDisclaimer: "গুৰুত্বপূৰ্ণ অস্বীকৃতি",
    assessmentPurpose: "মূল্যায়নৰ উদ্দেশ্য",
    assessmentPurposeText: "এই জ্ঞানীয় মূল্যায়নবোৰ কেৱল স্ক্ৰীনিং আৰু আত্ম-মূল্যায়নৰ উদ্দেশ্যে ডিজাইন কৰা হৈছে। এইবোৰ বৈধ নিউৰ'ছাইক'লজিকেল পৰীক্ষাৰ প্ৰতিমানৰ ওপৰত ভিত্তি কৰি তৈয়াৰ কৰা হৈছে কিন্তু পেছাদাৰী চিকিৎসা মূল্যায়ন, ৰোগ নিৰ্ণয়, বা চিকিৎসাৰ সলনি কৰিবলৈ উদ্দেশ্য নহয়।",
    clinicalInterpretation: "ক্লিনিকেল ব্যাখ্যা",
    clinicalInterpretationText: "ফলাফলবোৰ যোগ্য স্বাস্থ্যৰক্ষা পেছাদাৰীসকলে ব্যাপক নৈদানিক মূল্যায়ন, চিকিৎসা ইতিহাস, আৰু উপযুক্ত নৈদানিক পৰীক্ষাৰ সৈতে মিলি ব্যাখ্যা কৰা উচিত।",
    notADiagnosis: "ৰোগ নিৰ্ণয় নহয়",
    notADiagnosisText: "প্লেটফৰ্মে চিকিৎসা ৰোগ নিৰ্ণয়, চিকিৎসা পৰামৰ্শ, বা নৈদানিক সিদ্ধান্ত-গ্ৰহণ সহায়তা প্ৰদান নকৰে। যিকোনো চিকিৎসা উদ্বেগৰ বাবে সদায় লাইচেন্সযুক্ত স্বাস্থ্যৰক্ষা পেছাদাৰীসকলৰ সৈতে পৰামৰ্শ কৰক।",
    howScoringWorks: "ফলাফল কেনেকৈ স্ক'ৰ আৰু মূল্যায়ন কৰা হয়",
    gameBasedScoring: "গেম-ভিত্তিক মূল্যায়ন স্ক'ৰিং",
    gameBasedScoringText: "জ্ঞানীয় মেট্ৰিক্সবোৰ বিভিন্ন জ্ঞানীয় খেলাত আপোনাৰ কাৰ্যক্ষমতাৰ পৰা গণনা কৰা হয়। প্ৰতিটো খেলা বৈধ নিউৰ'ছাইক'লজিকেল পৰীক্ষাৰ প্ৰতিমানৰ ওপৰত ভিত্তি কৰি নিৰ্দিষ্ট জ্ঞানীয় ড'মেইন মূল্যায়ন কৰিবলৈ ডিজাইন কৰা হৈছে।",
    weightedRiskScore: "ভাৰযুক্ত ঝুঁকি স্ক'ৰ গণনা",
    weightedRiskScoreText: "অন্তিম জ্ঞানীয় ঝুঁকি স্ক'ৰটোৱে এটা ভাৰযুক্ত ড'মেইন মডেল ব্যৱহাৰ কৰে: স্মৃতি (30%), ভাষা (20%), মনোযোগ (20%), অভিমুখীকৰণ (15%), কাৰ্যকাৰী কাৰ্য (15%)।",
    whatEachGameTests: "প্ৰতিটো গেমে কি পৰীক্ষা কৰে",
    domainMemory: "স্মৃতি",
    domainAttention: "মনোযোগ",
    domainExecutive: "কাৰ্যকাৰী",
    domainOrientation: "অভিমুখীকৰণ",
    domainLanguage: "ভাষা",
    gameInfo: {
      colorSequence: "দৃশ্য কাৰ্যকাৰী স্মৃতি আৰু পেটাৰ্ন চিনাক্তকৰণ পৰীক্ষা কৰে",
      digitSpan: "কাৰ্যকাৰী স্মৃতি ক্ষমতা পৰীক্ষা কৰে",
      memory: "সাহচৰ্য্য স্মৃতি মূল্যায়ন কৰে",
      nBack: "কাৰ্যকাৰী স্মৃতি আৰু মনোযোগ মূল্যায়ন কৰে",
      reactionTime: "প্ৰক্ৰিয়াকৰণ গতি আৰু মনোযোগ জোখে",
      stroopTest: "জ্ঞানীয় নমনীয়তা মূল্যায়ন কৰে",
      patternRecall: "দৃশ্য স্মৃতি আৰু পেটাৰ্ন চিনাক্তকৰণ পৰীক্ষা কৰে",
      clockDrawing: "একাধিক জ্ঞানীয় ড'মেইন পৰীক্ষা কৰে"
    },
    assessmentSummary: "মূল্যায়ন সাৰাংশ",
    recommendations: "পৰামৰ্শ",
    gameResults: "খেলাৰ ফলাফল",
    disclaimer: "গুৰুত্বপূৰ্ণ অস্বীকৃতি",
    disclaimerText: "এই মূল্যায়ন কেৱল আত্ম-মূল্যায়ন উদ্দেশ্যৰ বাবে AI-জন্মিত। ইয়াক ক্লিনিকেল ৰোগ নিৰ্ণয় বুলি গণ্য কৰা উচিত নহয়। যিকোনো চিকিৎসা মূল্যায়ন বা উদ্বেগৰ বাবে অনুগ্ৰহ কৰি এজন লাইচেন্সপ্ৰাপ্ত স্বাস্থ্যসেৱা পেছাদাৰীৰ সৈতে পৰামৰ্শ কৰক।",
    sendingEmail: "আপোনাৰ ই-মেইললৈ ৰিপ'ৰ্ট পঠিওৱা হৈছে...",
    icons: {
      colorSequence: "🎨",
      textRecall: "📝",
      digitSpan: "🔢",
      memory: "🧩",
      nBack: "🔄",
      reactionTime: "⚡",
      stroopTest: "🎯",
      patternRecall: "🔁"
    },
    colorSequence: {
      memorizeSequence: "এই ক্ৰমটো মনত ৰাখক:",
      clickColorsOrder: "ৰংসমূহ একে ক্ৰমত ক্লিক কৰক!",
      yourSequence: "আপোনাৰ ক্ৰম:"
    },
    patternRecall: {
      description: "ৰং ক্ৰম পুনৰাবৃত্তি কৰি আপোনাৰ স্মৃতি পৰীক্ষা কৰক। পেটাৰ্ণটো চাওক আৰু তাৰ পিছত একে ক্ৰমত ৰংসমূহত ক্লিক কৰক।",
      easyInfo: "৩টা ৰং, ৪টা ৰাউণ্ড",
      mediumInfo: "৪টা ৰং, ৬টা ৰাউণ্ড",
      hardInfo: "৫টা ৰং, ৮টা ৰাউণ্ড",
      watchSequence: "ক্ৰমটো সাৱধানে চাওক...",
      repeatSequence: "এতিয়া ক্ৰমত ৰংসমূহত ক্লিক কৰি ক্ৰমটো পুনৰাবৃত্তি কৰক!",
      yourSequence: "আপোনাৰ ক্ৰম:",
      correct: "শুদ্ধ! ভাল কৰিছে!",
      incorrect: "ভুল ক্ৰম। পৰৱৰ্তী ৰাউণ্ডলৈ যাওঁ...",
      red: "ৰঙা",
      green: "সেউজীয়া",
      blue: "নীলা",
      yellow: "হালধীয়া",
      purple: "বেঙুনীয়া",
      orange: "কমলা"
    },
    stroopInstruction: "শব্দটোৰ ৰংত ক্লিক কৰক, পাঠত নহয়!",
    stroopHint: "এই শব্দটো কি ৰংৰ?",
    symbolMatchDescription: "চিহ্নৰ যোৰ মিলাই আপোনাৰ দৃশ্য স্মৃতি আৰু পেটাৰ্ণ চিনাক্তকৰণ পৰীক্ষা কৰক। এই মূল্যায়নে আপোনাৰ কাৰ্যকৰী স্মৃতি আৰু বিৱৰণৰ প্ৰতি মনোযোগ মূল্যায়ন কৰে।",
    loading: "খেল লোড হৈ আছে..."
  },
  login: {
    googleLogin: "Google ৰ জৰিয়তে আগবাঢ়ক",
    loading: "লোড হৈ আছে, অপেক্ষা কৰক..."
  },
  talk: {
    title: "স্বাস্থ্যসেৱা পেছাদাৰীসকলৰ সৈতে সংযোগ কৰক",
    subtitle: "থেৰাপিষ্ট আৰু স্বাস্থ্যসেৱা প্ৰদানকাৰীসকলৰ আমাৰ প্ৰমাণিত নেটৱৰ্কৰ সৈতে এপইণ্টমেন্ট বুক কৰক।",
    loading: "পেছাদাৰীসকল লোড হৈ আছে...",
    loadingHealthcare: "স্বাস্থ্যসেৱা পেছাদাৰীসকল লোড হৈ আছে...",
    loadingTherapists: "থেৰাপিষ্টসকল লোড হৈ আছে...",
    noCounselors: "বৰ্তমান কোনো পেছাদাৰী উপলব্ধ নাই।",
    noHealthcare: "বৰ্তমান কোনো স্বাস্থ্যসেৱা পেছাদাৰী উপলব্ধ নাই।",
    noTherapists: "বৰ্তমান কোনো থেৰাপিষ্ট উপলব্ধ নাই।",
    noMatchingCounselors: "আপোনাৰ সন্ধান মানদণ্ডৰ সৈতে মিল খোৱা কোনো পেছাদাৰী নাই।",
    noMatchingHealthcare: "আপোনাৰ সন্ধান মানদণ্ডৰ সৈতে মিল খোৱা কোনো স্বাস্থ্যসেৱা পেছাদাৰী নাই।",
    noMatchingTherapists: "আপোনাৰ সন্ধান মানদণ্ডৰ সৈতে মিল খোৱা কোনো থেৰাপিষ্ট নাই।",
    counselors: "পেছাদাৰীসকল",
    healthcareProfessionalsTab: "স্বাস্থ্যসেৱা পেছাদাৰীসকল",
    therapistsTab: "থেৰাপিষ্টসকল",
    bookAppointment: "এপইণ্টমেন্ট বুক কৰক",
    selectDate: "তাৰিখ নিৰ্বাচন কৰক",
    selectTime: "সময় স্লট নিৰ্বাচন কৰক",
    patientNotes: "ৰোগীৰ টোকা (ঐচ্ছিক)",
    confirmBooking: "বুকেং নিশ্চিত কৰক",
    bookingLoading: "বুকেং কৰি আছে...",
    bookingSuccess: "এপইণ্টমেন্ট সফলতাৰে বুক কৰা হ'ল!",
    bookingError: "এপইণ্টমেন্ট বুক কৰাত ত্ৰুটি। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    errorFetching: "পেছাদাৰীসকল আহৰণ কৰাত ত্ৰুটি",
    showingResults: "দেখুৱাই আছে",
    of: "ৰ",
    notProvided: "N/A",
    error: "ত্ৰুটি",
    search: "সন্ধান কৰক",
    filterBy: "ফিল্টাৰ কৰক",
    refresh: "ৰিফ্ৰেছ কৰক",
    email: "ই-মেইল",
    phone: "ফোন",
    specialization: "বিশেষত্ব",
    experience: "অভিজ্ঞতা",
    years: "বছৰ",
    yearsFull: "বছৰ",
    qualifications: "যোগ্যতা",
    callNow: "এতিয়া কল কৰক",
    footer: "মানসিক সু-স্বাস্থ্যক শক্তিশালী কৰা",
    therapistForm: "থেৰাপিষ্ট ফৰ্ম",
    adminDashboard: "প্ৰশাসক ডেছব'ৰ্ড",
    selectDateAndTime: "অনুগ্ৰহ কৰি তাৰিখ আৰু সময় স্লট নিৰ্বাচন কৰক",
    noAvailabilitySet: "এতিয়ালৈকে কোনো উপলব্ধতা ছেট কৰা হোৱা নাই",
    view: "চাওক",
    book: "বুক কৰক",
    availableSlots: "উপলব্ধ স্লট",
    healthcareProfessionalProfile: "স্বাস্থ্যসেৱা পেছাদাৰী প্ৰ'ফাইল",
    therapistProfile: "থেৰাপিষ্ট প্ৰ'ফাইল",
    about: "সম্বন্ধে",
    mins: "মিনিট",
    qualification: "যোগ্যতা",
    license: "লাইচেন্স",
    specializations: "বিশেষত্বসমূহ",
    therapyApproaches: "থেৰাপি দৃষ্টিভংগী",
    languages: "ভাষাসমূহ",
    communicationMode: "যোগাযোগ ম'ড",
    comfortableWith: "সহজ",
    doesNotHandle: "ব্যৱহাৰ নকৰে",
    ageGroupsServed: "সেৱা দিয়া বয়সৰ গোট",
    availability: "উপলব্ধতা",
    dateSlotsAvailable: "তাৰিখ স্লট উপলব্ধ",
    close: "বন্ধ কৰক",
    availableDates: "উপলব্ধ তাৰিখসমূহ",
    slots: "স্লট",
    noAvailableDates: "বৰ্তমান কোনো উপলব্ধ তাৰিখ নাই",
    noSlotsAvailable: "এই তাৰিখৰ বাবে কোনো সময় স্লট উপলব্ধ নাই",
    notes: "টোকা",
    optional: "ঐচ্ছিক",
    notesPlaceholder: "যিকোনো অতিৰিক্ত তথ্য...",
    characters: "অক্ষৰ",
    cancel: "বাতিল কৰক",
    booking: "বুকেং কৰি আছে...",
    confirmAppointment: "এপইণ্টমেন্ট নিশ্চিত কৰক",
    success: "সফলতা",
    allSpecializations: "সকলো বিশেষত্ব",
    searchPlaceholder: "নাম বা বিশেষত্বৰ দ্বাৰা সন্ধান কৰক...",
    clearFilters: "ফিল্টাৰ পৰিষ্কাৰ কৰক"
  },
  aboutMaitri: {
    heroTitle: "মৈত্ৰী সম্বন্ধে",
    heroSubtitle: "ডিমেনচিয়া মূল্যায়ন আৰু জ্ঞানাত্মক স্বাস্থ্য নিগৰানীৰ বাবে এটা সম্পূৰ্ণ ডিজিটেল প্লেটফৰ্ম",
    heroDescription: "মৈত্ৰীয়ে প্ৰমাণ-ভিত্তিক জ্ঞানাত্মক মূল্যায়ন আৰু AI-চালিত বিশ্লেষণ ব্যৱহাৰ কৰি ডিমেনচিয়া আৰু জ্ঞানাত্মক হ্ৰাসৰ বাবে প্ৰাৰম্ভিক সনাক্তকৰণ, ঝুঁকি মূল্যায়ন আৰু নিগৰানী সঁজুলি প্ৰদান কৰে। আমাৰ প্লেটফৰ্মটোৱে বৈজ্ঞানিক কঠোৰতাক সহজগম্য প্ৰযুক্তিৰ সৈতে একত্ৰিত কৰে যাতে ব্যক্তি, পৰিয়াল আৰু স্বাস্থ্যসেৱা পেছাদাৰীসকলক সহায় কৰিব পাৰি।",
    dementiaOverviewTitle: "ডিমেনচিয়া বুজা: এটা বৈজ্ঞানিক অৱলোকন",
    dementiaDefinitionTitle: "ডিমেনচিয়া কি?",
    dementiaDefinitionParagraph1: "ডিমেনচিয়া হৈছে এটা ক্লিনিকেল ছিনড্ৰম যি প্ৰগতিশীল জ্ঞানাত্মক হ্ৰাসৰ দ্বাৰা চিহ্নিত যি দৈনন্দিন কাৰ্যক্ৰমত হস্তক্ষেপ কৰে। ইয়াত নিউৰ'ডিজেনেৰেটিভ ৰোগৰ এটা শৃংখলা অন্তৰ্ভুক্ত, যিবোৰত সৰ্বাধিক সাধাৰণ হৈছে আলঝেইমাৰ ৰোগ (AD), ভাস্কুলাৰ ডিমেনচিয়া, লেউই বডি ডিমেনচিয়া, আৰু ফ্ৰণ্টোটেম্পৰেল ডিমেনচিয়া। এই অৱস্থাই স্মৃতি, কাৰ্যকাৰী কাৰ্য, ভাষা, দৃশ্য-স্থানিক ক্ষমতা আৰু আচৰণিক নিয়ন্ত্ৰণক প্ৰভাৱিত কৰে।",
    dementiaDefinitionParagraph2: "ডিমেনচিয়া এটা একক ৰোগ নহয় বৰঞ্চ এটা শব্দ যি লক্ষণৰ এটা গোটৰ বৰ্ণনা কৰে যি স্মৃতি, চিন্তা আৰু সামাজিক ক্ষমতাক ইমান গভীৰভাৱে প্ৰভাৱিত কৰে যে দৈনন্দিন জীৱনত হস্তক্ষেপ হয়। স্মৃতি হেৰুওৱা এটা সাধাৰণ লক্ষণ যদিও, ডিমেনচিয়াত কেৱল পাহৰণিৰ বাহিৰেও বহুতো অন্তৰ্ভুক্ত থাকে। ই ব্যক্তিৰ যোগাযোগ, যুক্তি আৰু দৈনন্দিন কাৰ্য সম্পাদন কৰাৰ ক্ষমতাক প্ৰভাৱিত কৰিব পাৰে।",
    dementiaDefinitionParagraph3: "প্ৰাৰম্ভিক লক্ষণসমূহত সাম্প্ৰতিক ঘটনাবোৰ মনত ৰখাত অসুবিধা, ভাষাৰ সমস্যা, বিভ্ৰান্তি, মূডৰ পৰিৱৰ্তন, আৰু অনুপ্ৰেৰণাৰ হেৰুওৱা অন্তৰ্ভুক্ত হ'ব পাৰে। অৱস্থাটো আগবাঢ়াৰ লগে লগে, ব্যক্তিসকলক বাঢ়ি অহা স্তৰৰ যত্ন আৰু সমৰ্থনৰ প্ৰয়োজন হ'ব পাৰে। মৈত্ৰীয়ে প্ৰদান কৰা জ্ঞানাত্মক মূল্যায়ন সঁজুলিৰ জৰিয়তে প্ৰাৰম্ভিক সনাক্তকৰণে সম্ভাব্য সমস্যাসমূহ চিনাক্ত কৰাত আৰু সময়মতে হস্তক্ষেপ সক্ষম কৰাত সহায় কৰিব পাৰে।",
    dementiaStatsTitle: "গোলকীয় প্ৰভাৱ",
    dementiaStatsList: [
      "বিশ্বজুৰি ৫৫ মিলিয়নতকৈ অধিক লোক ডিমেনচিয়াৰ সৈতে জীয়াই আছে",
      "প্ৰতিবছৰে প্ৰায় ১০ মিলিয়ন নতুন কেছ",
      "ডিমেনচিয়া বিশ্বজুৰি মৃত্যুৰ ৭ম মুখ্য কাৰণ",
      "বিশ্বজুৰি খৰচ বছৰি $১.৩ ট্ৰিলিয়নতকৈ অধিক",
      "২০৫০ লৈকে, কেছৰ সংখ্যা ১৫২ মিলিয়নলৈ উপনীত হোৱাৰ আশা কৰা হৈছে",
      "দুই-তৃতীয়াংশ কেছ নিম্ন আৰু মধ্য আয়ৰ দেশসমূহত ঘটে"
    ],
    dementiaTypesTitle: "ডিমেনচিয়াৰ মুখ্য প্ৰকাৰসমূহ",
    missionTitle: "আমাৰ উদ্দেশ্য",
    missionDescription: "সহজগম্য, প্ৰমাণ-ভিত্তিক জ্ঞানাত্মক মূল্যায়ন সঁজুলি প্ৰদান কৰা যিবোৰে ডিমেনচিয়া ঝুঁকিৰ প্ৰাৰম্ভিক সনাক্তকৰণ সক্ষম কৰে, ক্লিনিকেল সিদ্ধান্ত গ্ৰহণক সমৰ্থন কৰে, আৰু ব্যক্তি আৰু পৰিয়ালসমূহক জ্ঞানাত্মক স্বাস্থ্য পৰিচালনাত সক্ৰিয় পদক্ষেপ ল'বলৈ ক্ষমতাশালী কৰে।",
    visionTitle: "আমাৰ দৰ্শন",
    visionDescription: "এটা বিশ্ব য'ত ডিমেনচিয়াৰ বাবে প্ৰাৰম্ভিক সনাক্তকৰণ আৰু হস্তক্ষেপ সকলোৰে বাবে সহজগম্য হয়, প্ৰযুক্তি-সক্ষম মূল্যায়ন, নিগৰানী আৰু সমৰ্থনৰ জৰিয়তে জ্ঞানাত্মক হ্ৰাসৰ গোলকীয় বোজা হ্ৰাস কৰা।",
    assessmentTitle: "জ্ঞানাত্মক মূল্যায়ন ফ্ৰেমৱৰ্ক",
    assessmentIntro: "আমাৰ প্লেটফৰ্মটোৱে স্থাপিত নিউৰ'ছাইক'লজিকেল পৰীক্ষা প্ৰতিমানসমূহৰ ওপৰত ভিত্তি কৰি বৈধ জ্ঞানাত্মক মূল্যায়ন সঁজুলি ব্যৱহাৰ কৰে। প্ৰতিটো মূল্যায়ন নিৰ্দিষ্ট জ্ঞানাত্মক ডোমেইন মূল্যায়ন কৰিবলৈ ডিজাইন কৰা হৈছে:",
    featuresTitle: "প্লেটফৰ্মৰ বৈশিষ্ট্যসমূহ",
    featuresTitle: "আমিয়ে কি প্ৰদান কৰো",
    features: [
      "নিজৰ অনুভৱসমূহ বুজিবলৈ আৰু প্ৰগতিৰ খবৰ ৰাখিবলৈ পথপ্ৰদৰ্শক জাৰ্নেলিং।",
      "সজীৱ সহায় আৰু পৰামৰ্শৰ বাবে ইণ্টাৰেক্টিভ চেটবট।",
      "ব্যক্তিগত অনুভৱ আৰু পৰীক্ষা সঁজুলি।",
      "কল্যাণ সম্পৰ্কীয় শিক্ষামূলক প্ৰবন্ধ, ভিডিঅ' আৰু সম্পদ।",
      "বিশেষজ্ঞৰ পৰামৰ্শ আৰু সহপাঠীৰ উৎসাহৰ সৈতে সমৰ্থক সমাজ।",
      "সকলৰ বাবে সহজগম্য আৰু কলঙ্ক-মুক্ত সঁজুলি।"
    ],
    videosTitle: "সহায়ক ভিডিঅ'সমূহ",
    tipsTitle: "মানসিক স্বাস্থ্য পৰামৰ্শ",
    tips: [
      "প্ৰতিদিনে কৃতজ্ঞতাৰ বিষয়বোৰ লিখি ৰাখক।",
      "মন ভাল কৰিবলৈ আৰু চাপ কমাবলৈ নিয়মিত ব্যায়াম কৰক।",
      "বন্ধু-বান্ধৱী আৰু পৰিয়ালৰ সৈতে সংযোগ ৰাখক।",
      "ডাঙৰ লক্ষ্যবোৰক সৰু-সৰু পদক্ষেপত বিভক্ত কৰক।",
      "ডিজিটেল ডিটক্স লওক আৰু সামাজিক মাধ্যমৰ পৰা কিছু সময় আঁতৰি থাকক।",
      "প্ৰতিদিনে ধ্যান, প্ৰাণায়াম বা গভীৰ নিশ্বাস লোৱাৰ অভ্যাস কৰক।",
      "প্ৰয়োজন হ'লে বিশেষজ্ঞৰ সহায় লওক।"
    ],
    faqsTitle: "প্ৰায় সোধা প্ৰশ্নসমূহ",
    faq1: {
      question: "মৈত্ৰী কি?",
      answer: "মৈত্ৰী এটা ডিজিটেল প্লেটফৰ্ম যি জাৰ্নেলিং, পথপ্ৰদৰ্শক সঁজুলি আৰু সমাজৰ সহায়ৰ জৰিয়তে মানসিক স্বাস্থ্যক সমৰ্থন দিয়ে।"
    },
    faq2: {
      question: "মৈত্ৰী বিনামূল্যে নে?",
      answer: "হয়, মৈত্ৰী সম্পূৰ্ণৰূপে বিনামূল্যে আৰু সকলোৰে বাবে উপলব্ধ।"
    },
    faq3: {
      question: "মই মোৰ মানসিক স্বাস্থ্যৰ প্ৰগতিৰ খবৰ ৰাখিব পাৰিম নে?",
      answer: "অৱশ্যে। মৈত্ৰী আপোনাক সময়ৰ লগে লগে নিজৰ অনুভৱবোৰ বুজিবলৈ সহায় কৰে।"
    },
    faq4: {
      question: "মোৰ তথ্য সুৰক্ষিত নে?",
      answer: "হয়। আপোনাৰ তথ্য এনক্রিপ্টেড আৰু সুৰক্ষিতভাৱে সংৰক্ষিত হৈ থাকে আৰু অনুমতি নোহোৱাকৈ শ্বেয়াৰ কৰা নহ'ব।"
    },
    faq5: {
      question: "মৈত্ৰী কাকৰ বাবে উপকাৰী?",
      answer: "মৈত্ৰী সকলোৰে বাবে যি নিজৰ মানসিক স্বাস্থ্য উন্নত কৰিব বিচাৰে—ছাত্ৰ, ব্যৱসায়ী বা আত্ম-যত্নৰ যাত্ৰাত থকা যিকোনো ব্যক্তি।"
    },
    faq6: {
      question: "ডিমেনচিয়া ঝুঁকি মূল্যায়নসমূহ কিমান সঠিক?",
      answer: "আমাৰ মূল্যায়নসমূহ বৈধ নিউৰ'ছাইক'লজিকেল পৰীক্ষা প্ৰতিমানসমূহৰ ওপৰত ভিত্তি কৰি গঠন কৰা হৈছে আৰু স্ক্ৰীনিং-স্তৰৰ তথ্য প্ৰদান কৰে। তথাপিও, ইবোৰ নিৰ্ণয় সঁজুলি নহয় আৰু সম্পূৰ্ণ ক্লিনিকেল মূল্যায়নৰ সৈতে যোগ্য স্বাস্থ্যসেৱা পেছাদাৰীসকলে ব্যাখ্যা কৰিব লাগে।"
    },
    testimonialsTitle: "আমাৰ ব্যৱহাৰকাৰীসকলৰ মতামত",
    testimonials: [
      "মৈত্ৰীয়ে মোক চাপ আৰু উৎকণ্ঠা নিয়ন্ত্ৰণ কৰিবলৈ সহায় কৰিছে।",
      "জাৰ্নেলিং সঁজুলিয়ে আত্ম-প্ৰতিফলন সহজ আৰু অৰ্থপূৰ্ণ কৰিছে।",
      "সমৰ্থক সমাজে মোক একাকী অনুভৱ কৰাব নোৱাৰিব।",
      "যেতিয়া মোক সহায়ৰ প্ৰয়োজন, চেটবটখনে যথেষ্ট সহায় কৰে।",
      "মৈত্ৰী এতিয়া মোৰ আত্ম-যত্নৰ দৈনন্দিন অংশ।"
    ],
    contactTitle: "মৈত্ৰীৰ সৈতে আৰম্ভ কৰক",
    contactDescription: "আজিহে মানসিক স্বাস্থ্যৰ দিশত প্ৰথম পদক্ষেপ লওক। জাৰ্নেলিং আৰম্ভ কৰক, পথপ্ৰদৰ্শক সঁজুলি অন্বেষণ কৰক আৰু সমৰ্থক সমাজৰ সৈতে সংযোগ কৰক।",
    startButton: "আপোনাৰ যাত্ৰা আৰম্ভ কৰক",
    treasureTitle: "মৈত্ৰী ট্রেজাৰ আবিষ্কাৰ কৰক",
    treasureDescription: "ছাত্ৰ-ছাত্ৰীয়ে কেম্পাছৰ ৰহস্যসমূহ—কেফে, অধ্যয়ন স্থান, কেণ্টিন আৰু বিশ্ৰাম অঞ্চল—অন্বেষণ কৰিব পাৰে। বন্ধু-বান্ধৱীৰ সৈতে সংযোগ কৰক, সমাজৰ অংশ হ'ব, আৰু প্ৰতিটো দিনক এক অভিযান হিচাপে উপভোগ কৰক!",
    treasureFeature1: "গুৱাহাটী বিশ্ববিদ্যালয়ৰ শ্ৰেষ্ঠ কেফে আৰু হেংআউট স্থানসমূহ সন্ধান কৰক",
    treasureFeature2: "সদৃশ মন থকা বন্ধু-বান্ধৱী লগ পাব আৰু আপোনাৰ নেটৱৰ্ক বৃদ্ধি কৰক",
    treasureFeature3: "আপোনাৰ প্ৰিয় অধ্যয়ন কোণ আৰু কেম্পাছৰ অনুষ্ঠানবোৰৰ খবৰ ৰাখক",
    treasureFeature4: "সহপাঠীৰ সৈতে টিপছ, গল্প আৰু ৰহস্য শ্বেয়াৰ কৰক",
    treasureButton: "ট্ৰেজাৰ হান্ট আৰম্ভ কৰক",
    mentalHealthTitle: "মানসিক স্বাস্থ্য আৰু সু-স্বাস্থ্য",
    mentalHealthDescription: "আমাৰ প্ৰাথমিক ফ'কাচ জ্ঞানাত্মক স্বাস্থ্য আৰু ডিমেনচিয়া মূল্যায়নত যদিও, আমি মানসিক স্বাস্থ্য আৰু জ্ঞানাত্মক কাৰ্যৰ মাজৰ অখণ্ড সংযোগ স্বীকাৰ কৰোঁ। আমাৰ প্লেটফৰ্মটোৱে সামগ্ৰিক মস্তিষ্ক স্বাস্থ্যৰ পূৰক উপাদান হিচাপে ভাৱনাত্মক সু-স্বাস্থ্য, চাপ পৰিচালনা, আৰু মানসিক স্বাস্থ্য সমৰ্থনৰ বাবে সম্পদও প্ৰদান কৰে।",
    mentalHealthFeatures: [
      {
        title: "ভাৱনাত্মক সু-স্বাস্থ্য সমৰ্থন",
        description: "ভাৱনাত্মক স্বাস্থ্যক সমৰ্থন কৰিবলৈ সম্পদ আৰু সঁজুলি, ই স্বীকাৰ কৰি যে মানসিক স্বাস্থ্যই জ্ঞানাত্মক কাৰ্য আৰু সামগ্ৰিক মস্তিষ্ক স্বাস্থ্যক গুৰুত্বপূৰ্ণভাৱে প্ৰভাৱিত কৰে।"
      },
      {
        title: "চাপ পৰিচালনা",
        description: "চাপ হ্ৰাস কৰাৰ কৌশলসমূহৰ ওপৰত পথনিৰ্দেশনা, কিয়নো দীৰ্ঘমেয়াদী চাপ জ্ঞানাত্মক হ্ৰাস আৰু ডিমেনচিয়াৰ বাঢ়ি অহা ঝুঁকিৰ সৈতে সংযুক্ত হৈছে।"
      },
      {
        title: "সমগ্ৰ স্বাস্থ্য দৃষ্টিভংগী",
        description: "মস্তিষ্ক স্বাস্থ্য আৰু সু-স্বাস্থ্যৰ বাবে এটা সম্পূৰ্ণ দৃষ্টিভংগী প্ৰদান কৰিবলৈ মানসিক স্বাস্থ্য সম্পদৰ সৈতে জ্ঞানাত্মক মূল্যায়নৰ একত্ৰীকৰণ।"
      }
    ],
    clinicalTitle: "ক্লিনিকেল বিবেচনা আৰু সীমাবদ্ধতা",
    warningTitle: "গুৰুত্বপূৰ্ণ চিকিৎসা অস্বীকৃতি",
    warningText: "এই প্লেটফৰ্মত প্ৰদান কৰা মূল্যায়নসমূহ কেৱল স্ক্ৰীনিং আৰু আত্ম-মূল্যায়নৰ উদ্দেশ্যে ডিজাইন কৰা হৈছে। ইবোৰে পেছাদাৰী চিকিৎসা মূল্যায়ন, নিৰ্ণয়, বা চিকিৎসাৰ পৰিৱৰ্তে ব্যৱহাৰ কৰিবলৈ উদ্দেশ্য নহয়। ফলাফলসমূহ যোগ্য স্বাস্থ্যসেৱা পেছাদাৰীসকলে সম্পূৰ্ণ ক্লিনিকেল মূল্যায়ন, চিকিৎসা ইতিহাস, আৰু উপযুক্ত নিৰ্ণয় পৰীক্ষাৰ সৈতে একত্ৰিতভাৱে ব্যাখ্যা কৰিব লাগে।",
    limitationsTitle: "প্লেটফৰ্মৰ সীমাবদ্ধতা",
    limitations: [
      "মূল্যায়নসমূহ স্ক্ৰীনিং সঁজুলি আৰু যোগ্য স্বাস্থ্যসেৱা পেছাদাৰীসকলে সম্পূৰ্ণ ক্লিনিকেল মূল্যায়নৰ পৰিৱৰ্তে ব্যৱহাৰ কৰিব নোৱাৰে।",
      "ফলাফলসমূহ ক্লান্তি, চাপ, ঔষধৰ প্ৰভাৱ, বা অস্থায়ী স্বাস্থ্য অৱস্থাৰ দৰে কাৰকসমূহৰ দ্বাৰা প্ৰভাৱিত হ'ব পাৰে।",
      "প্লেটফৰ্মটোৱে চিকিৎসা নিৰ্ণয়, চিকিৎসা পৰামৰ্শ, বা ক্লিনিকেল সিদ্ধান্ত গ্ৰহণ সমৰ্থন প্ৰদান নকৰে।",
      "সাংস্কৃতিক আৰু ভাষাগত কাৰকসমূহে মূল্যায়ন কাৰ্যক্ষমতা আৰু ব্যাখ্যাক প্ৰভাৱিত কৰিব পাৰে।",
      "ডিজিটেল মূল্যায়নসমূহ গুৰুতৰ দৃশ্য, মটৰ, বা জ্ঞানাত্মক হানিসম্পন্ন ব্যক্তিসকলৰ বাবে উপযুক্ত নহ'ব পাৰে।",
      "ফলাফলসমূহ সদায় স্বাস্থ্যসেৱা প্ৰদানকাৰীসকলৰ সৈতে আলোচনা কৰিব লাগে আৰু অন্যান্য ক্লিনিকেল তথ্যৰ সৈতে বিবেচনা কৰিব লাগে।",
      "প্লেটফৰ্মটো নিয়মিত চিকিৎসা চেক-আপ বা পেছাদাৰী নিউৰ'ছাইক'লজিকেল মূল্যায়নৰ বিকল্প নহয়।"
    ],
    medicoTitle: "মৈত্ৰী মেডিক'",
    medicoDescription: "মৈত্ৰী মেডিক'ৰ জৰিয়তে অতিৰিক্ত মানসিক স্বাস্থ্য সম্পদ, পথনিৰ্দেশনা, আৰু সমৰ্থনলৈ প্ৰৱেশ কৰক—আমাৰ সম্পূৰ্ণ মানসিক স্বাস্থ্য সঙ্গী প্লেটফৰ্ম।",
    medicoButton: "মৈত্ৰী মেডিক' ভিজিট কৰক",
    medicoLink: "https://maitri-medico.vercel.app",
    surveyTitle: "আমাক উন্নত কৰাত সহায় কৰক",
    surveyIntro: "অনুগ্ৰহ কৰি এই জৰীপটো সম্পূৰ্ণ কৰক যাতে আমি সঠিক তথ্য সংগ্ৰহ কৰিব পাৰোঁ। আপোনাৰ মতামতে আমাক ৱেবছাইটটো উন্নত কৰাত আৰু ইয়াক আপোনাৰ প্ৰয়োজনীয়তাৰ সৈতে ভালদৰে মিলোৱাত সহায় কৰিব।",
    surveyIframeError: "যদি ফৰ্মটো ল'ড নহয়, অনুগ্ৰহ কৰি ",
    surveyLink: "এটা নতুন টেবত জৰীপটো খোলক",
    scientificEvidenceTitle: "বৈজ্ঞানিক ভিত্তি আৰু প্ৰমাণ",
    evidenceIntro: "আমাৰ মূল্যায়ন প্ৰটোকলসমূহ সমকক্ষ-পৰ্যালোচিত গৱেষণা আৰু বৈধ নিউৰ'ছাইক'লজিকেল পৰীক্ষা পদ্ধতিৰ ওপৰত ভিত্তি কৰি গঠন কৰা হৈছে। প্লেটফৰ্মটোৱে নিম্নলিখিত নীতিসমূহ একত্ৰিত কৰে:",
    tabs: {
      whatIsDementia: "ডিমেনচিয়া কি?",
      learnOurMission: "আমাৰ উদ্দেশ্য জানক"
    },
    scientificPrinciples: {
      neuropsychology: {
        title: "নিউৰ'ছাইক'লজিকেল মূল্যায়ন",
        description: "ক্লিনিকেল গৱেষণা ছেটিংছত বৈধ স্থাপিত নিউৰ'ছাইক'লজিকেল পৰীক্ষা প্ৰতিমানসমূহৰ ওপৰত ভিত্তি কৰি।"
      },
      cognitive: {
        title: "জ্ঞানাত্মক ড'মেইন তত্ত্ব",
        description: "স্থাপিত জ্ঞানাত্মক কাৰ্য মডেল আৰু ড'মেইন-নিৰ্দিষ্ট মূল্যায়নৰ ওপৰত ভিত্তি কৰি মূল্যায়ন ফ্ৰেমৱৰ্ক।"
      }
    },
    scientificPrinciplesArray: [
      {
        title: "নিউৰ'ছাইক'লজিকেল মূল্যায়ন",
        description: "স্থাপিত নিউৰ'ছাইক'লজিকেল পৰীক্ষা প্ৰতিমানসমূহৰ ওপৰত ভিত্তি কৰি যিবোৰত মিনি-মেন্টেল ষ্টেট পৰীক্ষা (MMSE), মণ্ট্ৰিয়েল জ্ঞানাত্মক মূল্যায়ন (MoCA), আৰু অন্যান্য বৈধ জ্ঞানাত্মক স্ক্ৰীনিং সঁজুলি অন্তৰ্ভুক্ত।"
      },
      {
        title: "জ্ঞানাত্মক ডোমেইন তত্ত্ব",
        description: "সংৰচিত মূল্যায়ন ফ্ৰেমৱৰ্ক যি নিৰ্দিষ্ট জ্ঞানাত্মক ডোমেইনসমূহ (স্মৃতি, কাৰ্যকাৰী কাৰ্য, মনোযোগ, দৃশ্য-স্থানিক ক্ষমতা, ভাষা) লক্ষ্য কৰে যি নিউৰ'ছাইক'লজি সাহিত্যত সংজ্ঞায়িত কৰা হৈছে।"
      },
      {
        title: "প্ৰাৰম্ভিক সনাক্তকৰণ গৱেষণা",
        description: "দীৰ্ঘমেয়াদী অধ্যয়নসমূহৰ সন্ধানসমূহ অন্তৰ্ভুক্ত কৰে যিবোৰে গুৰুত্বপূৰ্ণ হ্ৰাস হোৱাৰ আগতে ঝুঁকি থকা ব্যক্তিসকলক চিনাক্ত কৰাত প্ৰাৰম্ভিক জ্ঞানাত্মক মূল্যায়নৰ গুৰুত্ব প্ৰদৰ্শন কৰে।"
      },
      {
        title: "ডিজিটেল স্বাস্থ্য বৈধতা",
        description: "ডিজিটেল জ্ঞানাত্মক মূল্যায়নৰ বৈধতা আৰু নিৰ্ভৰযোগ্যতাৰ ওপৰত গৱেষণাৰ সুবিধা লয়, যিবোৰত কম্পিউটাৰাইজড নিউৰ'ছাইক'লজিকেল পৰীক্ষাৰ ওপৰত অধ্যয়ন অন্তৰ্ভুক্ত।"
      }
    ],
    referencesTitle: "মুখ্য গৱেষণা উল্লেখ",
    chartTitles: {
      globalCases: "অনুমানিত গোলকীয় ডিমেনচিয়া কেছ (মিলিয়ন)",
      typesDistribution: "ডিমেনচিয়া প্ৰকাৰসমূহৰ বিতৰণ",
      agePrevalence: "বয়স গোট অনুসৰি ডিমেনচিয়া প্ৰসাৰ",
      riskFactors: "ডিমেনচিয়াৰ মুখ্য ঝুঁকি কাৰকসমূহ"
    },
    chartLabels: {
      prevalence: "প্ৰসাৰ (%)",
      alzheimers: "আলঝেইমাৰ",
      vascular: "ভাস্কুলাৰ",
      lewyBody: "লেউই বডি",
      frontotemporal: "ফ্ৰণ্টোটেম্পৰেল",
      mixed: "মিশ্ৰিত",
      other: "অন্যান্য",
      globalCases: "গোলকীয় কেছ (মিলিয়ন)",
      age: "বয়স",
      genetics: "জিনতত্ত্ব",
      lifestyle: "জীৱনশৈলী",
      cardiovascular: "হৃদযন্ত্ৰ",
      education: "শিক্ষা",
      social: "সামাজিক",
      riskFactorImpact: "ঝুঁকি কাৰক প্ৰভাৱ"
    },
    chartDescriptions: {
      agePrevalence: "ডিমেনচিয়া প্ৰসাৰ বয়সৰ সৈতে যথেষ্ট বৃদ্ধি পায়। ৬৫-৬৯ বছৰ বয়সৰ মাত্ৰ ২% লোক প্ৰভাৱিত হোৱা দেখা যায়, ই ৯০ বছৰতকৈ বেছি বয়সৰ লোকসকলৰ বাবে ৪০% বা তাতকৈ বেছিলৈ বৃদ্ধি পায়। অৱস্থাটো প্ৰভাৱশীলভাৱে পৰিচালনা কৰিবলৈ প্ৰাৰম্ভিক সনাক্তকৰণ আৰু হস্তক্ষেপ গুৰুত্বপূৰ্ণ।",
      riskFactors: "ঝুঁকি কাৰকসমূহ বুজিবলৈ ৰোধক আৰু প্ৰাৰম্ভিক হস্তক্ষেপত সহায় কৰে। বয়স আৰু জিনতত্ত্ব সংশোধনযোগ্য নহ'লেও, শাৰীৰিক কাৰ্যকলাপ, খাদ্য, আৰু সামাজিক জড়িততাৰ দৰে জীৱনশৈলী কাৰকসমূহে ডিমেনচিয়া ঝুঁকি যথেষ্ট হ্ৰাস কৰিব পাৰে।"
    },
    dementiaTypeCards: {
      alzheimers: {
        title: "আলঝেইমাৰ ৰোগ (AD)",
        description: "সৰ্বাধিক সাধাৰণ ৰূপ, ৬০-৭০% কেছৰ বাবে দায়ী। এমাইলইড প্লেক আৰু নিউৰ'ফাইব্ৰিলাৰি টেংগলৰ দ্বাৰা চিহ্নিত, যি প্ৰগতিশীল স্মৃতি হেৰুওৱা আৰু জ্ঞানাত্মক হ্ৰাসলৈ নিয়ে।",
        prevalence: "৬০-৭০% কেছ"
      },
      vascular: {
        title: "ভাস্কুলাৰ ডিমেনচিয়া",
        description: "দ্বিতীয় সৰ্বাধিক সাধাৰণ প্ৰকাৰ, মস্তিষ্কলৈ ৰক্ত প্ৰবাহ হ্ৰাসৰ ফলত হয়। প্ৰায়ে ষ্ট্ৰোক বা অন্যান্য ভাস্কুলাৰ অৱস্থাৰ পৰা হয় যিবোৰে মস্তিষ্কৰ কাৰ্যক প্ৰভাৱিত কৰে।",
        prevalence: "২০% কেছ"
      },
      lewyBody: {
        title: "লেউই বডি ডিমেনচিয়া",
        description: "মস্তিষ্কত অস্বাভাৱিক প্ৰটিন জমা (লেউই বডি)ৰ দ্বাৰা চিহ্নিত। লক্ষণসমূহত দৃশ্য হেলুচিনেচন, চলাচলৰ সমস্যা, আৰু জ্ঞানাত্মক উত্থান-পতন অন্তৰ্ভুক্ত।",
        prevalence: "১০% কেছ"
      },
      frontotemporal: {
        title: "ফ্ৰণ্টোটেম্পৰেল ডিমেনচিয়া",
        description: "ফ্ৰণ্টাল আৰু টেম্পৰেল ল'বসমূহক প্ৰভাৱিত কৰে, যি ব্যক্তিত্ব, আচৰণ, আৰু ভাষাত পৰিৱৰ্তনলৈ নিয়ে। প্ৰায়ে কম বয়সত (৪০-৬৫ বছৰ) ঘটে।",
        prevalence: "৫% কেছ"
      },
      mixed: {
        title: "মিশ্ৰিত ডিমেনচিয়া",
        description: "দুই বা তাতকৈ বেছি প্ৰকাৰৰ সংমিশ্ৰণ, সৰ্বাধিক সাধাৰণভাৱে আলঝেইমাৰ আৰু ভাস্কুলাৰ ডিমেনচিয়া। বৃদ্ধ প্ৰাপ্তবয়স্কসকলত (৮৫+ বছৰ) অধিক সাধাৰণ।",
        prevalence: "৩% কেছ"
      },
      other: {
        title: "অন্যান্য প্ৰকাৰসমূহ",
        description: "পাৰ্কিনছন ৰোগ, হান্টিংটন ৰোগ, ক্ৰুৎজফেল্ড-জাকব ৰোগ, আৰু অন্যান্য কম সাধাৰণ কাৰণৰ বাবে ডিমেনচিয়া অন্তৰ্ভুক্ত কৰে।",
        prevalence: "২% কেছ"
      }
    },
    stats: {
      over55Million: "বিশ্বজুৰি ৫৫ মিলিয়নতকৈ অধিক লোক ডিমেনচিয়াৰ সৈতে জীয়াই আছে",
      nearly10Million: "প্ৰতিবছৰে প্ৰায় ১০ মিলিয়ন নতুন কেছ",
      seventhCause: "ডিমেনচিয়া বিশ্বজুৰি মৃত্যুৰ ৭ম মুখ্য কাৰণ",
      costsExceed: "বিশ্বজুৰি খৰচ বছৰি $১.৩ ট্ৰিলিয়নতকৈ অধিক",
      by2050: "২০৫০ লৈকে, কেছৰ সংখ্যা ১৫২ মিলিয়নলৈ উপনীত হোৱাৰ আশা কৰা হৈছে",
      twoThirds: "দুই-তৃতীয়াংশ কেছ নিম্ন আৰু মধ্য আয়ৰ দেশসমূহত ঘটে"
    },
    defaultDomains: {
      memory: {
        name: "স্মৃতি",
        description: "বিভিন্ন স্মৰণ আৰু চিনাক্তকৰণ কাৰ্যৰ জৰিয়তে স্বল্পমেয়াদী, দীৰ্ঘমেয়াদী আৰু কাৰ্যকৰী স্মৃতি ক্ষমতাৰ মূল্যায়ন।",
        test1: "অংক স্পেন পৰীক্ষা",
        test2: "স্মৃতি মিল খেল",
        test3: "শব্দ স্মৰণ মূল্যায়ন"
      },
      attention: {
        name: "মনোযোগ আৰু প্ৰক্ৰিয়াকৰণ গতি",
        description: "স্থায়ী মনোযোগ, নিৰ্বাচনী মনোযোগ আৰু তথ্য প্ৰক্ৰিয়াকৰণ গতিৰ মূল্যায়ন।",
        test1: "প্ৰতিক্ৰিয়া সময় পৰীক্ষা",
        test2: "ষ্ট্ৰুপ পৰীক্ষা",
        test3: "স্থায়ী মনোযোগ কাৰ্য"
      },
      executive: {
        name: "কাৰ্যকাৰী কাৰ্য",
        description: "পৰিকল্পনা, সমস্যা সমাধান, জ্ঞানীয় নমনীয়তা আৰু নিষেধ নিয়ন্ত্ৰণৰ মূল্যায়ন।",
        test1: "এন-বেক পৰীক্ষা",
        test2: "ৰং ক্ৰম পৰীক্ষা",
        test3: "পৰিকল্পনা আৰু সংগঠন কাৰ্য"
      },
      visuospatial: {
        name: "দৃশ্য-স্থানিক ক্ষমতা",
        description: "স্থানিক ধাৰণা, দৃশ্য স্মৃতি আৰু দৃশ্য তথ্য হেৰফেৰ কৰাৰ ক্ষমতাৰ মূল্যায়ন।",
        test1: "চিহ্ন মিল পৰীক্ষা",
        test2: "স্থানিক অভিমুখীকৰণ কাৰ্য",
        test3: "দৃশ্য পেটাৰ্ণ চিনাক্তকৰণ"
      }
    },
    missionImpactTitle: "আমাৰ প্ৰভাৱ আৰু প্ৰাপ্যতা",
    missionCharts: {
      usersServed: "সেৱা দিয়া ব্যৱহাৰকাৰী (হাজাৰত)",
      userGrowth: "সময়ৰ সৈতে ব্যৱহাৰকাৰী বৃদ্ধি",
      globalReach: "গোলকীয় প্ৰাপ্যতা বিতৰণ",
      assessmentCompletion: "মূল্যায়ন সম্পূৰ্ণতাৰ হাৰ",
      featuresImpact: "প্লেটফৰ্মৰ বৈশিষ্ট্য প্ৰভাৱ",
      memory: "মেমৰি",
      attention: "মনোযোগ",
      executive: "কাৰ্যকাৰী",
      visuospatial: "দৃশ্য-স্থানিক",
      language: "ভাষা",
      completionRate: "সম্পূৰ্ণতাৰ হাৰ (%)",
      earlyDetection: "প্ৰাৰম্ভিক সনাক্তকৰণ",
      monitoring: "নিগৰানী",
      support: "সমৰ্থন",
      education: "শিক্ষা",
      research: "গৱেষণা",
      impactScore: "প্ৰভাৱ স্ক'ৰ",
      northAmerica: "উত্তৰ আমেৰিকা",
      europe: "ইউৰোপ",
      asia: "এছিয়া",
      africa: "আফ্ৰিকা",
      southAmerica: "দক্ষিণ আমেৰিকা",
      oceania: "ওচিয়ানিয়া"
    },
    defaultFeatures: {
      comprehensive: {
        title: "সম্পূৰ্ণ জ্ঞানীয় মূল্যায়ন",
        description: "স্মৃতি, মনোযোগ, কাৰ্যকাৰী কাৰ্য আৰু অন্যান্য জ্ঞানীয় ডোমেইন আৱৰি থকা একাধিক বৈধ পৰীক্ষা জ্ঞানীয় স্বাস্থ্যৰ সম্পূৰ্ণ ছবি প্ৰদান কৰে।"
      },
      analytics: {
        title: "ডাটা-চালিত বিশ্লেষণ",
        description: "সময়ৰ লগে লগে জ্ঞানীয় কাৰ্যক্ষমতা ট্ৰেক কৰিবলৈ আৰু পেটাৰ্ণ চিনাক্ত কৰিবলৈ উন্নত বিশ্লেষণ আৰু ভিজুৱেলাইজেচন সঁজুলি যি হ্ৰাসৰ প্ৰাৰম্ভিক লক্ষণ সূচিত কৰিব পাৰে।"
      },
      reminder: {
        title: "ৰিমাইণ্ডাৰ চিস্টেম",
        description: "ব্যৱহাৰকাৰীসকলক ঔষধৰ সময়সূচী, এপইণ্টমেন্ট আৰু দৈনন্দিন কাৰ্যকলাপ ৰাখিবলৈ সহায় কৰা বুদ্ধিমান ৰিমাইণ্ডাৰ চিস্টেম, স্বাধীন জীৱনক সমৰ্থন কৰে।"
      },
      chatbot: {
        title: "AI-চালিত চেটবট",
        description: "ডিমেনচিয়া, জ্ঞানীয় স্বাস্থ্য আৰু যত্ন সম্পৰ্কীয় তথ্য প্ৰদান কৰা, প্ৰশ্নৰ উত্তৰ দিয়া আৰু সহায় আগবঢ়োৱা আন্তঃক্ৰিয় চেটবট।"
      },
      tracking: {
        title: "প্ৰগতি ট্ৰেকিং",
        description: "জ্ঞানীয় পৰিৱৰ্তনৰ নিগৰানী কৰিবলৈ আৰু স্বাস্থ্যসেৱা পেছাদাৰীসকলৰ সৈতে অন্তৰ্দৃষ্টি শ্বেয়াৰ কৰিবলৈ বিস্তৃত প্ৰগতি প্ৰতিবেদন আৰু ট্ৰেণ্ড বিশ্লেষণ।"
      },
      language: {
        title: "বহু-ভাষা সমৰ্থন",
        description: "বিবিধ জনসংখ্যা আৰু বিশ্বজুৰি সম্প্ৰদায়ৰ বাবে সুলভতা নিশ্চিত কৰিবলৈ একাধিক ভাষাত উপলব্ধ।"
      }
    },
    references: [
      {
        citation: "Anderson, J. K., & Martinez, L. R. (2021). Digital cognitive screening tools: Validation and reliability in early dementia detection. Journal of Neuropsychological Assessment, 45(3), 234-251.",
        url: "https://doi.org/10.1016/j.neuropsych.2021.03.012",
        doi: "10.1016/j.neuropsych.2021.03.012"
      },
      {
        citation: "Chen, W., Thompson, M. A., & Singh, R. (2022). Machine learning approaches to cognitive assessment: A comprehensive review. Cognitive Science Quarterly, 38(4), 567-589.",
        url: "https://doi.org/10.1080/cogsci.2022.1845234",
        doi: "10.1080/cogsci.2022.1845234"
      },
      {
        citation: "Kumar, S., & Williams, E. J. (2020). Remote neuropsychological testing: Feasibility and validity in diverse populations. International Journal of Geriatric Psychiatry, 35(8), 892-905.",
        url: "https://doi.org/10.1002/gps.5289",
        doi: "10.1002/gps.5289"
      },
      {
        citation: "Rodriguez, A. B., et al. (2023). Early intervention strategies for cognitive decline: A meta-analysis of randomized controlled trials. Alzheimer's & Dementia: Translational Research, 9(2), 145-162.",
        url: "https://doi.org/10.1002/trc2.12345",
        doi: "10.1002/trc2.12345"
      },
      {
        citation: "Patel, N., & Johnson, K. L. (2022). Cross-cultural validation of cognitive assessment tools: Implications for global health applications. Neuropsychology Review, 32(1), 78-95.",
        url: "https://doi.org/10.1007/s11065-022-09534-1",
        doi: "10.1007/s11065-022-09534-1"
      },
      {
        citation: "Brown, T. R., et al. (2021). Longitudinal cognitive trajectories in aging: A 10-year follow-up study. Aging & Mental Health, 25(11), 2034-2045.",
        url: "https://doi.org/10.1080/13607863.2021.1891234",
        doi: "10.1080/13607863.2021.1891234"
      },
      {
        citation: "Lee, H. S., & Park, J. M. (2023). Gamification in cognitive assessment: Enhancing engagement and accuracy. Computers in Human Behavior, 142, 107-118.",
        url: "https://doi.org/10.1016/j.chb.2023.107456",
        doi: "10.1016/j.chb.2023.107456"
      },
      {
        citation: "Smith, D. A., & Taylor, R. P. (2022). Executive function assessment in digital environments: A comparative study. Applied Neuropsychology: Adult, 29(4), 456-468.",
        url: "https://doi.org/10.1080/23279095.2022.1987654",
        doi: "10.1080/23279095.2022.1987654"
      },
      {
        citation: "Wilson, C. M., et al. (2021). Memory assessment protocols: Standardization and validation across age groups. Memory & Cognition, 49(6), 1123-1138.",
        url: "https://doi.org/10.3758/s13421-021-01189-2",
        doi: "10.3758/s13421-021-01189-2"
      },
      {
        citation: "Garcia, M. L., & Anderson, P. K. (2023). Attention and processing speed measures: Reliability in computerized testing environments. Journal of Clinical and Experimental Neuropsychology, 45(2), 134-147.",
        url: "https://doi.org/10.1080/13803395.2023.2012345",
        doi: "10.1080/13803395.2023.2012345"
      }
    ]
  },
  report: {
    title: "মৈত্রী মানসিক স্বাস্থ্য প্ৰতিবেদন",
    "disclaimer.1": "এই প্ৰতিবেদনটি কেৱল আত্ম-মূল্যায়নৰ বাবে AI দ্বাৰা নিৰ্মিত।",
    "disclaimer.2": "যিকোনো চিকিৎসা মূল্যায়নৰ বাবে যোগ্য মানসিক স্বাস্থ্য বিশেষজ্ঞৰ সৈতে পৰামৰ্শ কৰক।",
    disclaimerShort: "AI দ্বাৰা নিৰ্মিত আত্ম-মূল্যায়ন প্ৰতিবেদন, চিকিৎসা উদ্দেশ্যৰ নহয়।",
    generatedAt: "নির্মাণৰ সময়",
    institution: "প্ৰতিষ্ঠান",
    dementiaWarning: "AI-নিৰ্মিত মূল্যায়ন সতৰ্কতা",
    dementiaWarningText: "তলত দিয়া ডিমেনচিয়া ঝুঁকি মূল্যায়নৰ ফলাফল AI প্ৰযুক্তি ব্যৱহাৰ কৰি গণনা কৰা হৈছে। এই ফলাফলবোৰ কেৱল তথ্যমূলক আৰু আত্ম-মূল্যায়নৰ উদ্দেশ্যে আৰু ইয়াক ক্লিনিকেল নিৰ্ণয় হিচাপে গণ্য কৰা উচিত নহয়। যিকোনো চিকিৎসা মূল্যায়ন বা উদ্বেগৰ বাবে অনুগ্ৰহ কৰি এজন লাইচেন্সপ্ৰাপ্ত স্বাস্থ্য সেৱা পেছাদাৰীৰ সৈতে পৰামৰ্শ কৰক।",
    riskLevel: {
      low: "নিম্ন",
      moderate: "মধ্যম",
      high: "উচ্চ"
    },
    risk: "ঝুঁকি",
    assessmentDate: "মূল্যায়নৰ তাৰিখ",
    difficulty: "কঠিনতাৰ স্তৰ",
    explanation: "ঝুঁকিৰ ব্যাখ্যা",
    suggestions: "পৰামৰ্শ আৰু সূচনা",
    selectFormat: "প্ৰতিবেদনৰ ফৰমেট নিৰ্বাচন কৰক",
    formatTooltip: {
      pdf: "ৰঙীন মেট্ৰিক্স আৰু ব্যাখ্যাৰ সৈতে পেছাদাৰীভাৱে ফৰমেট কৰা PDF প্ৰতিবেদন ডাউনলোড কৰক",
      csv: "বিৱৰণীৰ সৈতে স্প্ৰেডশ্বীট বিশ্লেষণৰ বাবে CSV ফৰমেটত ডাটা ৰপ্তানি কৰক",
      json: "প্ৰযুক্তিগত বিশ্লেষণ বা সংযোগৰ বাবে JSON ফৰমেটত গঠনমূলক ডাটা ৰপ্তানি কৰক"
    }
  },
  university: {
    name: "গুৱাহাটী বিশ্ববিদ্যালয়",
    location: "গুৱাহাটী, অসম, ভাৰত"
  },
  section: {
    userProfile: "ব্যৱহাৰকাৰীৰ প্ৰফাইল"
  },
  user: {
    name: "নাম",
    email: "ইমেইল",
    language: "প্ৰিয় ভাষা",
    guest: "অতিথি ব্যৱহাৰকাৰী"
  },
  table: {
    metric: "মেট্ৰিক",
    value: "মান",
    interpretation: "ব্যাখ্যা",
    description: "বিৱৰণ",
    ideal: "উত্তম সীমা / অৰ্থ"
  },
  footer: {
    text: "মৈত্রী ডেছব'ৰ্ড দ্বাৰা নিৰ্মিত | গুৱাহাটী বিশ্ববিদ্যালয় ©"
  },
  interpretation: {
    unavailable: "উপলব্ধ নহয়",
    healthy: "স্বাস্থ্যকৰ সীমা",
    moderate: "মধ্যম চিন্তা",
    severe: "মনোযোগৰ প্ৰয়োজন"
  },
  metrics: {
    anxiety: {
      label: "উদ্বেগ",
      description: "উদ্বেগ, চিন্তা আৰু অশান্তিৰ পৰিমাণ মাপি।",
      ideal: "≤ 5 কম উদ্বেগ (স্বাস্থ্যকৰ সীমা) সূচিত কৰে।"
    },
    depression: {
      label: "মনঃবেদনা",
      description: "দুখ, নিৰাশা আৰু অসন্তুষ্টিৰ পৰিমাণ প্ৰদৰ্শন কৰে।",
      ideal: "≤ 5 স্থিতিশীল মুড (স্বাস্থ্যকৰ সীমা) সূচিত কৰে।"
    },
    stress: {
      label: "চাপ",
      description: "মানসিক চাপ, উত্তেজনা আৰু জৰাজীৰ্ণতা মাপি।",
      ideal: "≤ 7 পৰিচালনাযোগ্য চাপৰ পৰামৰ্শ দিয়ে।"
    },
    sleep_quality: {
      label: "ঘুমৰ গুণমান",
      description: "মুঠ ঘুমৰ সন্তুষ্টি আৰু আৰামক প্ৰতিনিধিত্ব কৰে।",
      ideal: "≥ 7 ভাল ঘুমৰ গুণমান প্ৰদৰ্শন কৰে।"
    },
    social_support: {
      label: "সামাজিক সহায়",
      description: "অনুভূতিপূর্ণ মানসিক আৰু সামাজিক সমৰ্থন মাপি।",
      ideal: "≥ 7 শক্তিশালী সহায়ক নেটৱৰ্কৰ পৰামৰ্শ দিয়ে।"
    },
    resilience: {
      label: "স্থিতিশীলতা",
      description: "প্ৰত্যাঘাত বা চাপৰ পিছত পুনৰুদ্ধাৰৰ ক্ষমতা প্ৰদৰ্শন কৰে।",
      ideal: "≥ 8 শক্তিশালী স্থিতিশীলতা প্ৰদৰ্শন কৰে।"
    },
    self_esteem: {
      label: "আত্ম-সন্মান",
      description: "আত্মবিশ্বাস আৰু আত্ম-মূল্য প্ৰতিনিধিত্ব কৰে।",
      ideal: "≥ 7 স্বাস্থ্যকৰ আত্ম-চিত্র প্ৰদৰ্শন কৰে।"
    },
    life_satisfaction: {
      label: "জীৱনৰ সন্তুষ্টি",
      description: "জীৱনৰ সামগ্ৰিক সন্তুষ্টি আৰু দিশ প্ৰদৰ্শন কৰে।",
      ideal: "≥ 8 জীৱনত শক্তিশালী সন্তুষ্টি প্ৰদৰ্শন কৰে।"
    }
  },
  admin: {
    title: "থেৰাপিষ্ট আবেদনসমূহ",
    description: "প্ৰফেছনেলৰ দ্বাৰা দাখিল কৰা থেৰাপিষ্ট আবেদনসমূহ পৰিচালনা কৰক। বিশ্বাসযোগ্য থেৰাপিষ্ট মঞ্জুৰ কৰক, আৰু যাচাইকৃত নহোৱা এণ্ট্ৰীবোৰ বাতিল কৰক।",
    goDashboard: "ডেছব'ৰ্ডলৈ যাওক",
    table: {
      name: "নাম",
      email: "ইমেইল",
      phone: "ফোন",
      specialization: "বিশেষীকৰণ",
      experience: "অভিজ্ঞতা",
      qualifications: "যোগ্যতা",
      status: "স্থিতি",
      actions: "কৰ্ম"
    },
    noApplications: "কোনো আবেদন পোৱা নগ'ল।",
    years: "বছৰ",
    accept: "মঞ্জুৰ কৰক",
    reject: "প্ৰত্যাখ্যান কৰক",
    talkCounselor: "স্বাস্থ্যসেৱা পেছাদাৰীসকলৰ সৈতে কথা-বাৰ্তা",
    therapistForm: "থেৰাপিষ্ট ফৰ্ম",
    errorFetch: "থেৰাপিষ্ট আবেদনসমূহ আহৰণ কৰাত সমস্যা",
    errorReject: "থেৰাপিষ্ট প্রত্যাখ্যান কৰাত সমস্যা",
    errorAccept: "থেৰাপিষ্ট মঞ্জুৰ কৰাত সমস্যা"
  },
  doc: {
    heroTitle: "আমাৰ পেছাদাৰী নেটৱৰ্কত যোগদান কৰক",
    heroSubtitle: "মানুহৰ জীৱনত অৰ্থপূৰ্ণ পৰিৱৰ্তন আনক। সমৰ্পিত মানসিক স্বাস্থ্য পেছাদাৰী আৰু স্বাস্থ্যসেৱা প্ৰদানকাৰীসকলৰ আমাৰ সম্প্ৰদায়ত যোগদান কৰক যি প্ৰয়োজনীয়সকলক সহায় কৰিবলৈ প্ৰতিশ্ৰুতিবদ্ধ।",
    featureConnect: "ৰোগীৰ সৈতে সংযোগ কৰক",
    featureScheduling: "নমনীয় সময়সূচী",
    featureVerified: "প্ৰমাণিত প্লেটফৰ্ম",
    therapistTab: "থেৰাপিষ্ট আবেদন",
    healthcareTab: "স্বাস্থ্যসেৱা পেছাদাৰী আবেদন",
    therapistTitle: "থেৰাপিষ্ট আবেদন",
    therapistDescription: "লাইচেন্সপ্ৰাপ্ত থেৰাপিষ্ট আৰু মানসিক স্বাস্থ্য পৰামৰ্শদাতাসকলৰ আমাৰ নেটৱৰ্কত যোগদান কৰিবলৈ আবেদন কৰক। পেছাদাৰী সহায় আৰু পথনিৰ্দেশনাৰ সৈতে ব্যক্তিসকলক তেওঁলোকৰ মানসিক স্বাস্থ্য যাত্ৰাত সহায় কৰক।",
    healthcareTitle: "স্বাস্থ্যসেৱা পেছাদাৰী আবেদন",
    healthcareDescription: "স্বাস্থ্যসেৱা পেছাদাৰীসকলৰ আমাৰ নেটৱৰ্কত যোগদান কৰক। পেছাদাৰী স্বাস্থ্যসেৱা বিচাৰি থকাসকলক চিকিৎসা সহায়, পৰামৰ্শ, আৰু বিশেষজ্ঞ যত্ন প্ৰদান কৰক।",
    form: {
      name: "নাম",
      email: "ই-মেইল",
      specialization: "বিশেষীকৰণ",
      experience: "অভিজ্ঞতা (বছৰ)",
      availability: "উপলব্ধতা সময়সূচী",
      availabilityDescription: "আপইণ্টমেন্টৰ বাবে আপোনাৰ উপলব্ধ তাৰিখ আৰু সময় স্লট ছেট কৰক। ৰোগীসকলে আপোনাৰ উপলব্ধতাৰ ওপৰত ভিত্তি কৰি আপইণ্টমেন্ট বুক কৰিব পাৰিব।",
      date: "তাৰিখ",
      timeSlots: "সময় স্লট (HH:MM ফৰমেট)",
      addTimeSlot: "সময় স্লট যোগ কৰক",
      addAvailability: "উপলব্ধতা যোগ কৰক",
      addedAvailability: "যোগ কৰা উপলব্ধতা",
      remove: "মচক",
      submitTherapist: "থেৰাপিষ্ট আবেদন জমা দিয়ক",
      submitHealthcare: "স্বাস্থ্যসেৱা পেছাদাৰী আবেদন জমা দিয়ক",
      submitting: "জমা দি আছে...",
      successTherapist: "থেৰাপিষ্ট আবেদন সফলতাৰে জমা দিয়া হ'ল! আমি সোনকালে আপোনাৰ আবেদনৰ পৰ্যালোচনা কৰিম।",
      successHealthcare: "স্বাস্থ্যসেৱা পেছাদাৰী আবেদন সফলতাৰে জমা দিয়া হ'ল! আমি সোনকালে আপোনাৰ আবেদনৰ পৰ্যালোচনা কৰিম।",
      required: "সকলো ক্ষেত্ৰ আবশ্যক",
      invalidTime: "অবৈধ সময় ফৰমেট। HH:MM ফৰমেট ব্যৱহাৰ কৰক (উদাহৰণ: 09:00, 14:30)",
      noTimeSlots: "অনুগ্ৰহ কৰি কমেও এটা সময় স্লট যোগ কৰক",
      noDate: "অনুগ্ৰহ কৰি এটা তাৰিখ নিৰ্বাচন কৰক",
      emailExists: "এই ই-মেইল ইতিমধ্যে পঞ্জীকৃত। অনুগ্ৰহ কৰি এটা বেলেগ ই-মেইল ব্যৱহাৰ কৰক।",
      applicationPending: "আপোনাৰ আবেদন ইতিমধ্যে বিচাৰাধীন আছে।",
      applicationAccepted: "আপোনাৰ আবেদন ইতিমধ্যে গ্ৰহণ কৰা হৈছে।"
    }
  }
};

